/* Skin Sapiens — Sunburn behaviour. One file, every Sunburn section.
   Each initialiser is idempotent so the theme editor can re-run it on section reload. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* funnel events (I-01): pushed to GTM's dataLayer and to Shopify customer events.
     No personal data: pincodes are reported as valid/invalid only (P-03). */
  function track(name, data) {
    data = data || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }
  function placeOf(el) {
    if (el.closest('.k-wd')) return 'saved_drawer';
    if (el.closest('.k-sticky')) return 'sticky_bar';
    if (el.closest('[data-k-fbt]')) return 'bundle';
    if (el.closest('.k-sm') || el.closest('.k-sec .k-wrap > p')) return 'routine';
    if (el.closest('.k-rl')) return 'reel';
    if (el.closest('.k-card, .k-nc')) return el.closest('#product-grid') ? 'collection_tile' : 'tile';
    if (el.closest('.k-float')) return 'float';
    if (el.closest('.k-tr')) return 'product_trust';
    return 'other';
  }

  /* one polite live region for every Sunburn status message (B-03: added, errors, results) */
  function announce(msg) {
    var r = document.getElementById('k-live');
    if (!r) {
      r = document.createElement('div');
      r.id = 'k-live';
      r.className = 'visually-hidden';
      r.setAttribute('role', 'status');
      r.setAttribute('aria-live', 'polite');
      document.body.appendChild(r);
    }
    r.textContent = '';
    setTimeout(function () { r.textContent = msg; }, 60);
  }

  /* announcement bar: one line at a time. Next slides up, previous slides down; arrows on desktop,
     swipe on phones. Autoplay holds while hovered or focused; reduced motion keeps the arrows
     and swipe but never autoplays. */
  function initAnnouncements(root) {
    root.querySelectorAll('.k-util [data-k-rotate]').forEach(function (box) {
      if (box.dataset.kInit) return;
      box.dataset.kInit = '1';
      var bar = box.closest('.k-util');
      var items = [].slice.call(box.querySelectorAll(':scope > .k-um'));
      var steps = bar.querySelectorAll('[data-k-step]');
      var ms = parseInt(box.dataset.kRotate, 10) || 4000;
      var i = 0, timer = null, held = false, paused = reduce;

      /* sale slide countdown (end time is India time); once it passes, the slide leaves the rotation */
      items.slice().forEach(function (el) {
        if (!el.dataset.kEnd) return;
        var end = Date.parse(el.dataset.kEnd + ':00+05:30');
        var cd = el.querySelector('.k-ucd'), u = {};
        if (cd) cd.querySelectorAll('[data-u]').forEach(function (b) { u[b.dataset.u] = b; });
        function pad(n) { return n < 10 ? '0' + n : '' + n; }
        function tick() {
          var s = Math.floor((end - Date.now()) / 1000);
          if (isNaN(end)) { if (cd) cd.hidden = true; clearInterval(clock); return; }
          if (s <= 0) { clearInterval(clock); drop(el); return; }
          if (!cd) return;
          u.d.textContent = Math.floor(s / 86400);
          u.h.textContent = pad(Math.floor(s / 3600) % 24);
          u.m.textContent = pad(Math.floor(s / 60) % 60);
          u.s.textContent = pad(s % 60);
          cd.hidden = false;
        }
        var clock = setInterval(tick, 1000);
        tick();
      });
      function drop(el) {
        var k = items.indexOf(el);
        if (k < 0) return;
        var wasOn = el.classList.contains('is-on');
        items.splice(k, 1);
        el.remove();
        if (!items.length) { bar.hidden = true; return; }
        if (k < i || i >= items.length) i = Math.max(0, i - (k < i ? 1 : 0)) % items.length;
        if (wasOn) items[i].classList.add('is-on');
        if (items.length < 2) { stop(); steps.forEach(function (b) { b.hidden = true; }); }
      }
      if (items.length < 2) return;

      function show(n, dir) {
        n = (n + items.length) % items.length;
        if (n === i) return;
        var was = items[i], now = items[n];
        now.style.transition = 'none';
        now.classList.toggle('is-out', dir < 0);
        void now.offsetWidth;
        now.style.transition = '';
        now.classList.remove('is-out');
        now.classList.add('is-on');
        was.classList.remove('is-on');
        was.classList.toggle('is-out', dir > 0);
        i = n;
      }
      function stop() { if (timer) { clearTimeout(timer); timer = null; } }
      function play() {
        stop();
        if (paused || held || document.hidden || items.length < 2) return;
        timer = setTimeout(function () { timer = null; show(i + 1, 1); play(); }, ms * (parseFloat(items[i].dataset.kHold) || 1));
      }
      function step(dir, via) { show(i + dir, dir); play(); track('sunburn_announcement_step', { index: i + 1, via: via }); }

      steps.forEach(function (b) {
        b.hidden = false;
        b.addEventListener('click', function () { step(parseInt(b.dataset.kStep, 10), 'arrow'); });
      });
      bar.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { held = true; stop(); } });
      bar.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { held = false; play(); } });
      bar.addEventListener('focusin', function () { held = true; stop(); });
      bar.addEventListener('focusout', function (e) { if (!bar.contains(e.relatedTarget)) { held = false; play(); } });
      document.addEventListener('visibilitychange', play);

      var x0 = null, y0 = 0;
      box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1, 'swipe');
      }, { passive: true });

      play();
    });
  }

  /* hero: each slide owns a photo and a copy panel; the named tabs pick one. It always autoplays
     (a JS clock; the tab's progress bar only shows it) and keeps playing after a tab is picked.
     It holds only while a mouse is over the shop buttons or keyboard focus is inside, and the
     pause button stops it (WCAG 2.2.2). Reduced motion keeps autoplay but drops the fades. */
  function initHero(root) {
    root.querySelectorAll('[data-k-hero]').forEach(function (hero) {
      if (hero.dataset.kInit) return;
      hero.dataset.kInit = '1';
      var slides = hero.querySelectorAll('[data-k-slide]');
      var tabs = hero.querySelectorAll('[data-k-tab]');
      var copyGroups = [hero.querySelectorAll('.k-hcopy-eb > [data-k-copy]'), hero.querySelectorAll('.k-hh > [data-k-copy]'), hero.querySelectorAll('.k-hswap > [data-k-copy]')];
      var pauseBtn = hero.querySelector('[data-k-pause]');
      if (slides.length < 2 || !tabs.length) return;
      var DUR = parseInt(hero.dataset.kHero, 10) || 6000;
      var cur = 0, paused = false, held = false, away = false, timer = null, started = 0, left = DUR;

      function run() {
        if (timer || paused || held || away || document.hidden) return;
        started = Date.now();
        timer = setTimeout(function () { timer = null; go((cur + 1) % slides.length); }, left);
      }
      function stop() {
        if (!timer) return;
        clearTimeout(timer); timer = null;
        left = Math.max(0, left - (Date.now() - started));
      }
      function setOn(list, i) {
        list.forEach(function (el, k) {
          el.classList.toggle('is-on', k === i);
          if (k === i) el.removeAttribute('inert'); else el.setAttribute('inert', '');
        });
      }
      function go(i, how) {
        cur = i;
        setOn(slides, i);
        copyGroups.forEach(function (g) { if (g.length) setOn(g, Math.min(i, g.length - 1)); });
        tabs.forEach(function (t, k) {
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
          t.tabIndex = k === i ? 0 : -1;
          var bar = t.querySelector('.k-htab-bar i');
          if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
        });
        if (timer) { clearTimeout(timer); timer = null; }
        left = DUR;
        run();
        if (how) track('sunburn_hero_slide', { index: i + 1, via: how });
      }
      function hold(on) {
        held = on;
        hero.classList.toggle('is-held', on);
        if (on) stop(); else run();
      }
      function setPaused(p) {
        paused = p;
        hero.classList.toggle('is-paused', p);
        if (pauseBtn) {
          pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
          pauseBtn.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow');
        }
        if (p) stop(); else run();
      }

      tabs.forEach(function (t, k) { t.addEventListener('click', function () { go(k, 'tab'); }); });
      hero.querySelector('.k-htabs').addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = (cur + d + slides.length) % slides.length;
        go(n, 'key'); tabs[n].focus();
      });
      /* hold only where a change would be annoying: a mouse on the shop buttons, or keyboard focus */
      hero.querySelectorAll('.k-cta').forEach(function (c) {
        c.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold(true); });
        c.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold(false); });
      });
      hero.addEventListener('focusin', function (e) {
        var kb = false;
        try { kb = e.target.matches(':focus-visible'); } catch (err) {}
        if (kb) hold(true);
      });
      hero.addEventListener('focusout', function (e) { if (held && !hero.contains(e.relatedTarget)) hold(false); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else run(); });
      if (pauseBtn) {
        pauseBtn.hidden = false;
        pauseBtn.addEventListener('click', function () {
          setPaused(!paused);
          track('sunburn_rotation_toggle', { paused: paused });
        });
      }
      /* theme editor: selecting a slide block shows it and stops the clock */
      hero.addEventListener('shopify:block:select', function (e) {
        slides.forEach(function (s, k) { if (s === e.target || s.contains(e.target)) { setPaused(true); go(k); } });
      });
      /* actives sit on one line; if a row would overflow, show it as two even columns instead */
      function fitActives() {
        var rows = hero.querySelectorAll('.k-hact');
        rows.forEach(function (ul) { ul.classList.remove('is-grid'); });
        var over = Array.prototype.map.call(rows, function (ul) { return ul.scrollWidth > ul.clientWidth + 1; });
        rows.forEach(function (ul, i) { if (over[i]) ul.classList.add('is-grid'); });
      }
      fitActives();
      var fitT;
      window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitActives, 120); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitActives);
      hero.classList.add('is-playing');
      go(0);
      /* scrolled away: no slide changes (fades, photo zoom, decodes) nobody sees; it picks up where it left off */
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
        away = !es[es.length - 1].isIntersecting;
        hero.classList.toggle('is-away', away);
        if (away) stop(); else run();
      }).observe(hero);
    });
  }

  function initRails(root) {
    root.querySelectorAll('[data-k-rail]').forEach(function (wrap) {
      if (wrap.dataset.kInit) return;
      wrap.dataset.kInit = '1';
      var rail = wrap.querySelector('[data-k-track]') || wrap.querySelector('.k-rail');
      var prev = wrap.querySelector('.k-prev');
      var next = wrap.querySelector('.k-next');
      if (!rail || !prev || !next) return;
      /* one card plus the gap; the product carousel moves a full view at a time */
      function step() {
        var c = rail.firstElementChild;
        if (!c) return 200;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 14;
        var one = c.getBoundingClientRect().width + gap;
        return rail.hasAttribute('data-k-track') ? Math.max(one, Math.floor((rail.clientWidth + gap) / one) * one) : one;
      }
      var prog = wrap.querySelector('[data-k-prog]'), raf = 0;
      function sync() {
        raf = 0;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
        wrap.classList.toggle('is-static', max <= 0);
        /* optional progress line: the thumb is the visible share of the track, slid by the scroll */
        if (prog && rail.scrollWidth) {
          var share = rail.clientWidth / rail.scrollWidth;
          prog.style.width = (share * 100) + '%';
          prog.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * ((1 / share) - 1) * 100 : 0) + '%)';
        }
      }
      prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      function later() { if (!raf) raf = requestAnimationFrame(sync); }
      rail.addEventListener('scroll', later, { passive: true });
      window.addEventListener('resize', later);
      sync();
    });
  }

  /* review cards: a customer photo opens in the section's dialog, stepping through that review's photos */
  function initRvPhotos(root) {
    root.querySelectorAll('[data-k-rvlb]').forEach(function (dlg) {
      if (dlg.dataset.kInit || typeof dlg.showModal !== 'function') return;
      dlg.dataset.kInit = '1';
      var sec = dlg.closest('section') || root;
      var img = dlg.querySelector('[data-k-rvlb-img]');
      var count = dlg.querySelector('[data-k-rvlb-n]');
      var list = [];
      var at = 0;
      var opener = null;
      function show(i) {
        at = (i + list.length) % list.length;
        img.src = list[at];
        count.textContent = (at + 1) + ' / ' + list.length;
      }
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('[data-k-rvimg]');
        if (!b || !sec.contains(b)) return;
        list = b.getAttribute('data-k-rvimg').split('|').filter(Boolean);
        if (!list.length) return;
        opener = b;
        dlg.classList.toggle('is-one', list.length < 2);
        show(0);
        dlg.showModal();
      });
      dlg.addEventListener('click', function (e) {
        var step = e.target.closest('[data-k-rvlb-step]');
        if (step) { show(at + parseInt(step.getAttribute('data-k-rvlb-step'), 10)); return; }
        /* the close button, or a click on the backdrop (the dialog box itself, outside its content) */
        if (e.target.closest('[data-k-rvlb-close]') || e.target === dlg) dlg.close();
      });
      dlg.addEventListener('keydown', function (e) {
        if (list.length < 2) return;
        if (e.key === 'ArrowRight') show(at + 1);
        if (e.key === 'ArrowLeft') show(at - 1);
      });
      dlg.addEventListener('close', function () { if (opener) opener.focus(); });
    });
  }

  /* trust bar: on phones it is a swipe row; the dots follow whichever item sits at the left edge */
  function initTrust(root) {
    root.querySelectorAll('[data-k-trust]').forEach(function (row) {
      if (row.dataset.kInit) return;
      row.dataset.kInit = '1';
      var dots = row.parentNode.querySelectorAll('.k-tdots i');
      if (!dots.length) return;
      var raf = 0;
      row.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(dot); }, { passive: true });
      function dot() {
        raf = 0;
        var items = row.children, left = row.getBoundingClientRect().left, best = 0, bd = Infinity;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(items[i].getBoundingClientRect().left - left);
          if (d < bd) { bd = d; best = i; }
        }
        if (row.scrollLeft + row.clientWidth >= row.scrollWidth - 4) best = items.length - 1;
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
      }
    });
  }

  var barIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.querySelectorAll('.k-track i').forEach(function (i, k) {
        setTimeout(function () { i.style.width = i.dataset.w + '%'; }, 80 * k);
      });
      barIO.unobserve(e.target);
    });
  }, { threshold: 0.4 }) : null;

  function initBars(root) {
    root.querySelectorAll('[data-k-bars]').forEach(function (el) {
      if (barIO && !reduce) barIO.observe(el);
      else el.querySelectorAll('.k-track i').forEach(function (i) { i.style.width = i.dataset.w + '%'; });
    });
  }

  /* reels strip: clips play muted while half on screen and stop off screen. One clip has sound at a time.
     The invisible tap layer pauses/resumes (WCAG 2.2.2); with reduced motion nothing autoplays and a tap starts it. */
  var reelIO = null;
  function reelPlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function initReels(root) {
    var clips = root.querySelectorAll('.k-rl video');
    if (!clips.length) return;
    if (!reelIO && 'IntersectionObserver' in window) {
      reelIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target, rl = v.closest('.k-rl');
          if (!e.isIntersecting) { v.pause(); return; }
          if (!reduce && !rl.dataset.kHeld) reelPlay(v);
        });
      }, { threshold: 0.5 });
    }
    clips.forEach(function (v) {
      var rl = v.closest('.k-rl');
      if (rl.dataset.kInit) return;
      rl.dataset.kInit = '1';
      var bar = rl.querySelector('.k-rl-bar'), tap = rl.querySelector('.k-rl-tap'), snd = rl.querySelector('.k-rl-snd');
      var name = (tap && tap.getAttribute('aria-label') || '').replace(/^Pause /, '');
      function mark() {
        var off = v.paused;
        rl.classList.toggle('is-paused', off && (reduce || !!rl.dataset.kHeld));
        if (tap) tap.setAttribute('aria-label', (off ? 'Play ' : 'Pause ') + name);
      }
      if (reduce) rl.classList.add('is-paused');
      v.addEventListener('play', mark);
      v.addEventListener('pause', mark);
      v.addEventListener('timeupdate', function () {
        if (bar && v.duration) bar.style.setProperty('--p', (v.currentTime / v.duration).toFixed(4));
      });
      if (tap) tap.addEventListener('click', function () {
        if (v.paused) { delete rl.dataset.kHeld; reelPlay(v); }
        else { rl.dataset.kHeld = '1'; v.pause(); }
        mark();
      });
      if (snd) snd.addEventListener('click', function () {
        var on = v.muted;
        document.querySelectorAll('.k-rl video').forEach(function (o) { o.muted = true; });
        document.querySelectorAll('.k-rl-snd').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.setAttribute('aria-label', b.getAttribute('aria-label').replace(/^Sound off/, 'Sound on'));
        });
        v.muted = !on;
        snd.setAttribute('aria-pressed', on ? 'true' : 'false');
        snd.setAttribute('aria-label', snd.getAttribute('aria-label').replace(/^Sound o(n|ff)/, on ? 'Sound off' : 'Sound on'));
        if (on) { delete rl.dataset.kHeld; reelPlay(v); }
        track('sunburn_reel_sound', { on: on });
      });
      if (reelIO) reelIO.observe(v);
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (a) {
      if (/wa\.me\//.test(a.href)) track('sunburn_whatsapp_click', { place: placeOf(a) });
      else if (a.classList.contains('k-buy')) track('sunburn_buy_now', { place: placeOf(a) });
      else if (a.classList.contains('k-chip')) track('sunburn_filter_chip', { label: a.textContent.trim(), group: (a.parentNode.getAttribute('aria-label') || '') });
      else if (a.closest('.k-rail')) track('sunburn_concern_click', { label: (a.querySelector('.k-cap-t') || a).textContent.trim() });
      else if (a.closest('.k-recent')) track('sunburn_recently_viewed_click', {});
    }
    if (cardClick(e)) return;
    var btn = e.target.closest('[data-k-add]');
    if (!btn || btn.hasAttribute('data-k-gb')) return;
    e.preventDefault();
    gGroup(btn);
  });

  /* ---- cart drawer (option D) and the cart page built from it: pack chips + kit swap post
     /cart/update.js; undo after a remove. A button on the cart page (inside [data-k-cp]) re-renders
     the page section quietly (gSections); one in the drawer re-renders the drawer. ---- */
  function cartPage() { return document.querySelector('[data-k-cp]'); }
  function cartPost(url, body, onPage) {
    var drawer = document.querySelector('cart-drawer');
    if (onPage) {
      body.sections = gSecs();
      body.sections_url = window.location.pathname;
    } else if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  function drawerRender(res, empty, onPage) {
    if (onPage) {
      if (!res.sections || !res.sections[cartPage().dataset.kCp]) { window.location.reload(); return; }
      gSections(res.sections);
      if (res.items) { gRebuild(res); gPaintAll(); }
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') { window.location.reload(); return; }
    drawer.classList.toggle('is-empty', !!empty);
    drawer.renderContents({ id: null, sections: res.sections });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-k-cart-update]');
    if (!b || b.classList.contains('is-busy')) return;
    e.preventDefault();
    var updates;
    try { updates = JSON.parse(b.dataset.kCartUpdate); } catch (err) { return; }
    var swap = b.classList.contains('k-cd-swap');
    var onPage = !!b.closest('[data-k-cp]');
    b.classList.add('is-busy');
    b.setAttribute('aria-busy', 'true');
    cartPost(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', { updates: updates }, onPage)
      .then(function (res) {
        drawerRender(res, false, onPage);
        if (b.dataset.kCartSay) announce(b.dataset.kCartSay + '.');
        track(swap ? 'sunburn_cart_kit_swap' : 'sunburn_cart_pack', { updates: b.dataset.kCartUpdate });
      })
      .catch(function (err) {
        b.classList.remove('is-busy');
        b.removeAttribute('aria-busy');
        announce(((err && (err.description || err.message)) || 'We could not update your bag.') + ' Try again.');
      });
  });

  /* remove (× or the bin at quantity 1): by line key, not Dawn's line number, so a drawer drawn
     before the cart changed elsewhere can never remove the wrong line or bring one back.
     Taken in the capture phase so neither cart-remove-button nor quantity-input sees the click. */
  var undoT;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('cart-drawer [data-k-key], [data-k-cp] [data-k-key]');
    if (!b) return;
    var onPage = !b.closest('cart-drawer');
    e.preventDefault();
    e.stopPropagation();
    if (b.getAttribute('aria-busy')) return;
    var p = (b.dataset.kUndo || '').split(':');
    var u = { id: parseInt(p[0], 10), q: parseInt(p[1], 10) || 1, name: b.dataset.kUndoName || 'Item' };
    var row = b.closest('.k-cd-w');
    if (row) row.classList.add('is-out');
    b.setAttribute('aria-busy', 'true');
    cartPost(((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js', { id: b.dataset.kKey, quantity: 0 }, onPage)
      .then(function (res) {
        drawerRender(res, res.item_count === 0, onPage);
        showUndo(u, onPage);
        announce(u.name + ' removed from your bag.');
        track('sunburn_cart_remove', { variant_id: u.id });
      })
      .catch(function (err) {
        if (row) row.classList.remove('is-out');
        b.removeAttribute('aria-busy');
        announce(((err && (err.description || err.message)) || 'We could not remove ' + u.name + '.') + ' Try again.');
      });
  }, true);
  function showUndo(u, onPage) {
    var slot = document.querySelector(onPage ? '[data-k-cp] [data-k-cd-undo]' : 'cart-drawer [data-k-cd-undo]');
    if (!slot || !u.id) return;
    clearTimeout(undoT);
    slot.innerHTML = '<div class="k-cd-undo" role="status"><span></span><button type="button">Undo</button></div>';
    slot.querySelector('span').textContent = 'Removed ' + u.name;
    var btn = slot.querySelector('button'), shown = Date.now();
    btn.addEventListener('click', function () {
      /* a second tap meant for the list right after a remove is not an undo */
      if (Date.now() - shown < 700 || btn.disabled) return;
      btn.disabled = true;
      clearTimeout(undoT);
      cartPost(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { items: [{ id: u.id, quantity: u.q }] }, onPage)
        .then(function (res) {
          if (onPage) return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); }).then(function (cart) { cart.sections = res.sections; return cart; });
          return res;
        })
        .then(function (res) { drawerRender(res, false, onPage); announce(u.name + ' is back in your bag.'); track('sunburn_cart_undo', { variant_id: u.id }); })
        .catch(function () { btn.disabled = false; announce('We could not put ' + u.name + ' back. Try again.'); });
    });
    undoT = setTimeout(function () { slot.innerHTML = ''; }, 6000);
  }

  /* ---- notched product card: pack sheet and save heart ---- */
  function sheetOf(card) { return card && card.querySelector('.k-nc-sheet'); }
  function closeSheet(card, refocus) {
    var sh = sheetOf(card), opener = card && card.querySelector('[data-k-sheet]');
    if (!sh || sh.hidden) return;
    var buyer = sh.classList.contains('is-buy') && card.querySelector('[data-k-buy-sheet]');
    sh.hidden = true;
    sh.classList.remove('is-buy');
    if (buyer) { buyer.setAttribute('aria-expanded', 'false'); if (refocus) buyer.focus(); return; }
    if (opener) { opener.setAttribute('aria-expanded', 'false'); if (refocus) opener.focus(); }
  }
  /* ---- card Buy now: add one and go straight to checkout; the rest of the bag stays ---- */
  function buyNow(id, btn) {
    if (!id || btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    track('sunburn_buy_now', { place: placeOf(btn), variant_id: id });
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function () { window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout'; })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        announce((err && err.description) || 'We could not start checkout. Try again.');
      });
  }
  /* coming back from checkout restores the page from cache with the spinner still on */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-k-buy].is-busy, .k-nc-opt.is-busy').forEach(function (b) { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); });
  });
  /* ---- Genie add to bag: every add button on the site ----
     Adding pours a copy of what is being bought into the button that was tapped, like a macOS window
     minimising to the Dock (down into a corner button, sideways into a button beside the photo).
     The button catches it with a spring and becomes the cart with the count.
     - Units (a single product: product cards, steps plates and kit, reel docks, the product page and its
       sticky bar): a − n + pill opens above the button; tapping the cart takes one out, and the last one out
       plays the Genie in reverse. The drawer stays closed; the header count and the drawer's contents
       refresh quietly, so the shopper stays put.
     - Groups ("Add all", the bundle, Saved drawer's Add all): each photo pours in turn, the button says
       Added. Buttons inside the cart drawer or the Saved drawer hand over to the cart drawer as before.
     Cards follow the real cart: /cart.js on load, and again whenever the header count changes elsewhere.
     Motion: every spring is mass-spring-damper (k = stiffness, c = damping, mass 1), simulated at 240 Hz
     and baked into 60 fps keyframes, so speed carries from one phase into the next. */
  var G = {
    press: { to: 0.9, k: 1400, c: 52 },   /* finger down: quick, firm dip */
    release: { k: 640, c: 12 },           /* finger up: about 4 % past rest, two bounces */
    pourIn: 560,                          /* copy pours into the button (ms) */
    pourOut: 500,                         /* last one out: copy comes back out, slowing as it lands (ms) */
    lift: { at: 0.15, px: 10 },           /* the copy rises 10 px over the first 15 % before it drops */
    swell: 0.12, pillSwell: 0.05,         /* the button opens to catch (wide buttons less) */
    follow: { k: 760, c: 30 },
    squash: { k: 700, c: 15, kick: 8.5 }, /* impact: ~1.16 x 0.91, settled ~550 ms later */
    nudge: { k: 700, c: 13, kick: 5 },    /* +, − and cart taps */
    morphAt: 0.86,                        /* the icon turns into the cart at 86 % of the pour */
    stepper: { delay: 90, k: 420, c: 19 },/* the pill pops out of the button just after impact */
    land: { k: 500, c: 16, kick: -0.35 }, /* the source gives a small bounce when the copy lands back */
    groupGap: 80,                         /* group adds: each photo starts 80 ms after the last */
    hide: 5000                            /* the − n + pill closes 5 s after the last touch */
  };
  var gCart = null, gSelfAt = 0, gPressed = null, gLoad = null;
  /* sections every cart write re-renders: the drawer, the header count, and the cart page when on it */
  function gSecs() {
    var cp = cartPage();
    return 'cart-drawer,cart-icon-bubble' + (cp ? ',' + cp.dataset.kCp : '');
  }
  var G_CART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2.5 3.5h2.4l2.3 11.2h11.1l2.2-8H6.1" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>';
  var G_WHEELS = '<circle cx="9" cy="19" r="1.5" fill="currentColor"/><circle cx="17" cy="19" r="1.5" fill="currentColor"/></svg>';
  var G_ICONS = '<span class="k-g-add">' + G_CART + '<path d="M13.3 8.3v4.6M11 10.6h4.6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' + G_WHEELS + '</span>'
    + '<span class="k-g-in">' + G_CART + '<text x="13.3" y="14.3" text-anchor="middle" font-size="10" fill="currentColor">1</text>' + G_WHEELS + '</span>';

  function gSim(chans, minMs) {
    var dt = 1 / 240, t = 0, out = [], step = 0;
    chans.forEach(function (ch) { ch.x = ch.from; ch.v = ch.v || 0; });
    while (t < 3) {
      if (step % 4 === 0) out.push(chans.map(function (ch) { return ch.x; }));
      var still = true;
      chans.forEach(function (ch) {
        var to = typeof ch.to === 'function' ? ch.to(t) : ch.to;
        var a = -ch.k * (ch.x - to) - ch.c * ch.v;
        ch.v += a * dt; ch.x += ch.v * dt;
        if (Math.abs(ch.x - to) > 0.0008 || Math.abs(ch.v) > 0.02) still = false;
      });
      t += dt; step++;
      if (still && t * 1000 > (minMs || 0)) break;
    }
    out.push(chans.map(function (ch) { return typeof ch.to === 'function' ? ch.to(t) : ch.to; }));
    return out;
  }
  /* one script animation per element: a new one replaces the last, so a held press never comes back */
  function gPlay(el, rows, map, opts) {
    if (!el || !el.animate) return null;
    if (el._ga) el._ga.cancel();
    el._ga = el.animate(rows.map(function (r) { return map.apply(null, r); }), Object.assign({ duration: rows.length * 1000 / 60, easing: 'linear' }, opts || {}));
    return el._ga;
  }
  /* scale s and squash q (q > 0: wider and shorter); wide buttons squash a third as much */
  function gBt(s, q, wide) {
    var k = wide ? 0.3 : 1;
    return { transform: 'translateY(' + (q * 3 * k).toFixed(2) + 'px) scale(' + (s * (1 + 0.55 * q * k)).toFixed(4) + ',' + (s * (1 - 0.65 * q * k)).toFixed(4) + ')' };
  }
  function gWait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function gWide(btn) { return btn.offsetWidth > 120; }
  /* where a button's scale starts: the dip if the finger just lifted off it */
  function gFrom(el) { var p = el._s === G.press.to; if (p) el._took = true; return p ? G.press.to : 1; }

  var G_PRESS = '[data-k-gb], .k-gs button, [data-k-add], .k-nc-opt[data-k-ga], [data-k-card] button.k-nc-cart';
  document.addEventListener('pointerdown', function (e) {
    var el = e.target.closest(G_PRESS);
    if (!el || reduce || el.disabled) return;
    gPressed = el; el._s = G.press.to; el._took = false;
    gPlay(el, gSim([{ from: 1, to: G.press.to, k: G.press.k, c: G.press.c }]), function (s) { return gBt(s, 0); }, { fill: 'forwards' });
  });
  function gUp() {
    var el = gPressed; if (!el) return; gPressed = null;
    setTimeout(function () {
      if (el._s !== G.press.to) return;
      el._s = 1;
      if (el._took) { el._took = false; return; }
      gPlay(el, gSim([{ from: G.press.to, to: 1, k: G.release.k, c: G.release.c }]), function (s) { return gBt(s, 0); });
    }, 0);
  }
  document.addEventListener('pointerup', gUp);
  document.addEventListener('pointercancel', gUp);

  /* cart state: variant id -> { q, key } */
  function gRebuild(cart) {
    gCart = {};
    (cart.items || []).forEach(function (it) {
      var m = gCart[it.variant_id] || (gCart[it.variant_id] = { q: 0, key: it.key });
      m.q += it.quantity;
    });
  }
  /* an add answers with the lines it touched, each carrying its new total */
  function gTake(res) {
    if (!gCart) gCart = {};
    (res.items || [res]).forEach(function (it) { if (it && it.variant_id) gCart[it.variant_id] = { q: it.quantity, key: it.key }; });
  }
  function gFetch() {
    return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { gRebuild(cart); gPaintAll(); });
  }
  function gSend(url, body) {
    return fetch(url + '.js', { method: 'POST', headers: body instanceof FormData ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body instanceof FormData ? body : JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  function gPost(url, body) {
    if (body instanceof FormData) { body.append('sections', gSecs()); body.append('sections_url', window.location.pathname); }
    else { body.sections = gSecs(); body.sections_url = window.location.pathname; }
    return gSend(url, body);
  }
  var G_ADD = function () { return (window.routes && window.routes.cart_add_url) || '/cart/add'; };
  var G_CHANGE = function () { return (window.routes && window.routes.cart_change_url) || '/cart/change'; };
  /* refresh the header count and the drawer's contents without opening the drawer */
  function gSections(sections) {
    if (!sections) return;
    gSelfAt = Date.now();
    var parse = function (html, sel) { return html ? new DOMParser().parseFromString(html, 'text/html').querySelector(sel) : null; };
    var bub = document.getElementById('cart-icon-bubble'), nb = parse(sections['cart-icon-bubble'], '.shopify-section');
    if (bub && nb) bub.innerHTML = nb.innerHTML;
    var drawer = document.querySelector('cart-drawer'), cd = document.getElementById('CartDrawer'), nd = parse(sections['cart-drawer'], '#CartDrawer');
    if (drawer && cd && nd) {
      cd.innerHTML = nd.innerHTML;
      drawer.classList.toggle('is-empty', !!cd.querySelector('.drawer__inner.is-empty'));
      var ov = cd.querySelector('#CartDrawer-Overlay');
      if (ov && drawer.close) ov.addEventListener('click', drawer.close.bind(drawer));
    }
    var cp = cartPage(), np = cp && parse(sections[cp.dataset.kCp], '[data-k-cp]');
    if (cp && np) {
      cp.innerHTML = np.innerHTML;
      cp.classList.toggle('is-empty', np.classList.contains('is-empty'));
    }
  }
  function gBumpBag() {
    var i = document.querySelector('#cart-icon-bubble .svg-wrapper, #cart-icon-bubble svg');
    if (i && !reduce) gPlay(i, gSim([{ from: 1, to: 1, k: G.squash.k, c: G.squash.c, v: 4 }]), function (s) { return { transform: 'scale(' + s.toFixed(4) + ')' }; });
  }

  /* macOS Genie on a copy of the source. spec: { host, face } pours a DOM copy inside host (cards, plates,
     reels, drawer rows); { img } pours a copy of a photo over the page (product page, sticky bar, groups),
     at z-index spec.z when it must stay under something (default: above the page and the sticky bar).
     The pour runs along the axis toward the button: down into a corner button, sideways into a button
     beside the photo. The real source stays put. 'out' plays the same frames reversed. */
  function gGenie(spec, dir) {
    var btn = spec.btn, face = spec.face || spec.img;
    if (!face || !btn || !face.getBoundingClientRect) return Promise.resolve();
    var fr = face.getBoundingClientRect(), br = btn.getBoundingClientRect();
    var fixed = !spec.host, F = { left: fr.left, top: fr.top, width: fr.width, height: fr.height };
    if (fixed) {
      /* a photo mostly off screen: pour a copy that sits just above the button instead */
      var vis = Math.max(0, Math.min(fr.bottom, innerHeight) - Math.max(fr.top, 0)) / Math.max(1, fr.height);
      if (vis < 0.4 || fr.width < 8) {
        var w = Math.min(220, innerWidth * 0.5), h = w * (fr.height / Math.max(1, fr.width) || 1);
        F = { width: w, height: h, left: Math.max(8, Math.min(innerWidth - w - 8, br.left + br.width / 2 - w / 2)), top: Math.max(8, br.top - h - 24) };
      }
    }
    var W = F.width, H = F.height;
    if (W < 4 || H < 4) return Promise.resolve();
    var bx = br.left + br.width / 2 - F.left, by = br.top + br.height / 2 - F.top;
    var vert = true, flip = false;
    if (by >= H * 0.85) vert = true;
    else if (by <= H * 0.1) { vert = true; flip = true; }
    else if (bx >= W * 0.9) vert = false;
    else if (bx <= W * 0.1) { vert = false; flip = true; }
    var L = vert ? H : W, C = vert ? W : H, bAlong = vert ? br.height : br.width;
    var ab = (vert ? by : bx); if (flip) ab = L - ab; ab -= bAlong * 0.05;
    var cb = vert ? bx : by, c0 = (vert ? br.width : br.height) * 0.42;
    /* ~6px strips, at most 64: each strip is a full copy of the face, so more strips cost a long first frame */
    var n = Math.max(12, Math.min(64, Math.round(L / 6))), sh = L / n, steps = 48, reach = ab + sh + 6;
    var pour = function (p) { var q = Math.max(0, (p - G.lift.at * 0.7) / (1 - G.lift.at * 0.7)); return q * q * (0.3 + 0.7 * q); };
    return new Promise(function (done) {
      var layer = document.createElement('div');
      layer.className = 'k-g-layer' + (fixed ? ' is-fixed' : '');
      layer.setAttribute('aria-hidden', 'true');
      var hr = fixed ? { left: 0, top: 0 } : spec.host.getBoundingClientRect();
      layer.style.cssText = 'left:' + (F.left - hr.left) + 'px;top:' + (F.top - hr.top) + 'px;width:' + W + 'px;height:' + H + 'px' + (spec.z ? ';z-index:' + spec.z : '');
      var radius = fixed ? getComputedStyle(face).borderRadius : '';
      var rows = face.style && !fixed ? getComputedStyle(face).gridTemplateRows : '';
      var frames = [];
      for (var i = 0; i < n; i++) {
        var a0 = i * sh, ac = a0 + sh / 2, gate = Math.max(0, ab - ac), pos = flip ? L - a0 - sh : a0;
        var s = document.createElement('div'), c;
        if (fixed) {
          c = document.createElement('img');
          c.src = face.currentSrc || face.src; c.alt = '';
          c.style.cssText = 'object-fit:cover;border-radius:' + radius;
        } else {
          c = face.cloneNode(true);
          c.querySelectorAll('[id]').forEach(function (x) { x.removeAttribute('id'); });
          if (rows && rows !== 'none') c.style.gridTemplateRows = rows;
        }
        s.className = 'k-g-s';
        s.style.cssText = vert ? 'left:0;top:' + pos + 'px;width:' + W + 'px;height:' + (sh + 0.75) + 'px' : 'top:0;left:' + pos + 'px;height:' + H + 'px;width:' + (sh + 0.75) + 'px';
        c.style.position = 'absolute'; c.style.margin = '0';
        c.style.left = (vert ? 0 : -pos) + 'px'; c.style.top = (vert ? -pos : 0) + 'px';
        c.style.width = W + 'px'; c.style.height = H + 'px';
        s.appendChild(c); layer.appendChild(s);
        var kf = [];
        for (var f = 0; f <= steps; f++) {
          var p = f / steps, a = Math.min(1, p / 0.5), bend = a * a * (3 - 2 * a);
          var lift = p < G.lift.at ? -Math.sin(p / G.lift.at * Math.PI) * G.lift.px : 0;
          var d = pour(p) * reach, u = Math.max(0, Math.min(1, (ac + d) / ab)), k = bend * u * u * (3 - 2 * u);
          var wid = C - (C - c0) * k, shift = (cb - C / 2) * k, op = Math.max(0, Math.min(1, (gate + 8 - d) / 8));
          var go = (flip ? -1 : 1) * (d + lift);
          kf.push({ transform: vert ? 'translate(' + shift.toFixed(2) + 'px,' + go.toFixed(2) + 'px) scaleX(' + (wid / C).toFixed(4) + ')'
            : 'translate(' + go.toFixed(2) + 'px,' + shift.toFixed(2) + 'px) scaleY(' + (wid / C).toFixed(4) + ')', opacity: op });
        }
        if (dir === 'out') kf.reverse();
        frames.push(kf);
      }
      if (fixed) document.body.appendChild(layer);
      else spec.host.insertBefore(layer, spec.host.firstChild);
      var last;
      Array.prototype.forEach.call(layer.children, function (s, i) {
        last = s.animate(frames[i], { duration: dir === 'in' ? G.pourIn : G.pourOut, easing: 'linear', fill: 'forwards' });
      });
      /* the clock is a backstop: a dropped finish event must not leave the button busy (dead) for good */
      var safe = setTimeout(finish, (dir === 'in' ? G.pourIn : G.pourOut) + 600);
      function finish() { clearTimeout(safe); if (layer.parentNode) layer.remove(); done(); }
      last.onfinish = finish;
    });
  }

  /* ---- units: one product, one button, one − n + pill ---- */
  function gVars(unit) { return unit._getV ? [String(unit._getV() || '')].filter(Boolean) : (unit.dataset.kVariants || '').split(',').filter(Boolean); }
  function gActive(unit) {
    if (!gCart) return null;
    if (unit._v && gVars(unit).indexOf(String(unit._v)) > -1 && gCart[unit._v] && gCart[unit._v].q > 0) return unit._v;
    return gVars(unit).filter(function (id) { return gCart[id] && gCart[id].q > 0; })[0] || null;
  }
  function gQty(unit) { var v = gActive(unit); return v ? gCart[v].q : 0; }
  function gPlace(unit) {
    var st = unit._st, b = unit._btn;
    if (!st || !b) return;
    var ur = unit.getBoundingClientRect(), br = b.getBoundingClientRect(), w = st.offsetWidth;
    var cx = (gWide(b) ? br.right - Math.min(56, br.width / 2) : br.left + br.width / 2) - ur.left;
    var left = Math.max(0, Math.min(ur.width - w, cx - w / 2));
    st.style.left = left + 'px'; st.style.right = 'auto';
    st.style.bottom = (ur.bottom - br.top + 9) + 'px';
    st.style.setProperty('--ax', (cx - left) + 'px');
  }
  function gPaint(unit, d, morphOnly) {
    var btn = unit._btn, st = unit._st;
    if (!btn || !st) return;
    var n = st.querySelector('.k-gs-n'), q = gQty(unit), name = btn.dataset.kName || '';
    if (btn.dataset.kLabel0 == null) btn.dataset.kLabel0 = btn.getAttribute('aria-label') || '';
    unit.classList.toggle('is-in-bag', q > 0);
    if (btn.classList.contains('k-gpill')) btn.classList.toggle('is-narrow', btn.offsetWidth > 0 && btn.offsetWidth < 170);
    if (unit._root) unit._root.classList.toggle('k-g-inbag', q > 0);
    if (!q) { unit.classList.remove('is-open'); clearTimeout(unit._ht); }
    if (q) btn.setAttribute('aria-label', name + ', ' + q + ' in your bag. Remove one');
    else if (btn.dataset.kLabel0) btn.setAttribute('aria-label', btn.dataset.kLabel0);
    else btn.removeAttribute('aria-label');
    if (btn.hasAttribute('data-k-sheet')) { if (q) btn.removeAttribute('aria-controls'); else btn.setAttribute('aria-controls', btn.dataset.kSheet); }
    if (!q) return;
    btn.querySelectorAll('.k-g-in text').forEach(function (t) { t.textContent = q > 99 ? '99' : q; });
    var old = n.firstElementChild;
    if (old && old.textContent == q) return;
    var nw = document.createElement('span'); nw.textContent = q;
    if (old) n.replaceChild(nw, old); else n.appendChild(nw);
    /* the count rolls up when it grows, down when it shrinks */
    if (d && !reduce) gPlay(nw, gSim([{ from: 0, to: 1, k: 560, c: 20 }]), function (p) { return { transform: 'translateY(' + ((1 - p) * (d > 0 ? 80 : -80)).toFixed(1) + '%)', opacity: Math.min(1, p * 1.6) }; });
  }
  function gPaintAll() { document.querySelectorAll('[data-k-gu]').forEach(function (u) { if (!u._busy && u._btn) gPaint(u); }); }
  /* the pill closes itself once it has been left alone for G.hide (hover or focus on the pill keeps it) */
  function gArm(unit) {
    clearTimeout(unit._ht);
    unit._ht = setTimeout(function () {
      var st = unit._st;
      if (!st || !unit.classList.contains('is-open')) return;
      /* a mouse over the pill or the cart holds it (leaving closes it at once, see pointerout); so does keyboard focus */
      if (gHeld(unit)) { gArm(unit); return; }
      gCloseStepper(unit);
    }, G.hide);
  }
  /* touch screens keep :hover on the last thing tapped, so hover only counts while a real mouse is in use */
  var gMouse = false;
  document.addEventListener('pointerdown', function (e) { gMouse = e.pointerType === 'mouse'; }, true);
  document.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') gMouse = true; }, { passive: true });
  function gHeld(unit) {
    var st = unit._st, b = unit._btn;
    if (!st) return false;
    if (st.querySelector(':focus-visible')) return true;
    return gMouse && (st.matches(':hover') || (!!b && b.matches(':hover')));
  }
  /* quick: the mouse left, so it tucks away at once (~120 ms) instead of springing */
  function gCloseStepper(unit, quick) {
    var st = unit._st;
    clearTimeout(unit._ht);
    if (!st || !unit.classList.contains('is-open')) return;
    if (st.querySelector(':focus-visible') && unit._btn) unit._btn.focus({ preventScroll: true });
    if (reduce) { unit.classList.remove('is-open'); return; }
    /* it goes back down into the button */
    var shape = function (p) { return { transform: 'translateY(' + ((1 - p) * 12).toFixed(2) + 'px) scale(' + (0.35 + 0.65 * p).toFixed(4) + ')', opacity: Math.max(0, Math.min(1, p * 2.5)) }; };
    var a = quick
      ? (st._ga && st._ga.cancel(), st._ga = st.animate([shape(1), shape(0)], { duration: 120, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' }))
      : gPlay(st, gSim([{ from: 1, to: 0, k: 520, c: 34 }]), shape, { fill: 'forwards' });
    var end = function () { unit._closing = null; unit.classList.remove('is-open'); if (a) a.cancel(); };
    unit._closing = a;
    if (a) a.onfinish = end; else end();
  }
  function gOpenStepper(unit) {
    var st = unit._st;
    /* reopened while it was closing: drop the close and pop it out again */
    if (unit._closing) { unit._closing.onfinish = null; unit._closing.cancel(); unit._closing = null; unit.classList.remove('is-open'); }
    gArm(unit);
    if (unit.classList.contains('is-open')) return;
    unit.classList.add('is-open');
    gPlace(unit);
    if (reduce || !st) return;
    gPlay(st, gSim([{ from: 0, to: 1, k: G.stepper.k, c: G.stepper.c }]), function (p) {
      return { transform: 'translateY(' + ((1 - p) * 12).toFixed(2) + 'px) scale(' + (0.35 + 0.65 * p).toFixed(4) + ')', opacity: Math.min(1, p * 2.5) };
    });
    st.querySelectorAll('button').forEach(function (b, i) {
      var dir = i ? -1 : 1;
      gPlay(b, gSim([{ from: 0, to: 1, k: G.stepper.k, c: G.stepper.c - 3 }]), function (p) {
        return { transform: 'translateX(' + ((1 - p) * 14 * dir).toFixed(2) + 'px) scale(' + (0.6 + 0.4 * p).toFixed(3) + ')' };
      }, { delay: 40 });
    });
  }
  function gImpact(btn) {
    if (reduce) return;
    gPlay(btn, gSim([{ from: 1 + (gWide(btn) ? G.pillSwell : G.swell), to: 1, k: G.follow.k, c: G.follow.c }, { from: 0, to: 0, k: G.squash.k, c: G.squash.c, v: G.squash.kick }]),
      function (s, q) { return gBt(s, q, gWide(btn)); });
    gBumpBag();
  }
  function gSwell(btn) {
    if (reduce) return;
    var amt = gWide(btn) ? G.pillSwell : G.swell;
    var to = function (t) { var a = Math.max(0, Math.min(1, (t / (G.pourIn / 1000) - 0.12) / 0.5)); return 1 + amt * a * a * (3 - 2 * a); };
    gPlay(btn, gSim([{ from: gFrom(btn), to: to, k: G.follow.k, c: G.follow.c }], G.pourIn), function (s) { return gBt(s, 0); }, { fill: 'forwards' });
  }
  function gShake(btn) {
    if (reduce) return;
    gPlay(btn, [0, 0.2, 0.4, 0.6, 0.8, 1].map(function (t) { return [t]; }), function (t) { return { transform: 'translateX(' + (Math.sin(t * Math.PI * 4) * 5 * (1 - t)).toFixed(2) + 'px)' }; }, { duration: 380 });
  }
  function gPourAll(specs, dir) {
    if (reduce || !specs.length) return Promise.resolve();
    /* a failed pour is only a missing animation; it never blocks the add or the button */
    return Promise.all(specs.map(function (s, i) { return gWait(i * G.groupGap).then(function () { return gGenie(s, dir); }); })).catch(function () {});
  }

  function gAdd(unit, vid, src) {
    var btn = unit._btn;
    if (unit._busy || !btn) return;
    unit._busy = true; unit._v = vid;
    btn.setAttribute('aria-busy', 'true');
    var name = (src && src.dataset.kName) || btn.dataset.kName || 'Item';
    var form = unit._form ? new FormData(unit._form) : null;
    var req = gPost(G_ADD(), form || { items: [{ id: parseInt(vid, 10), quantity: 1 }] });
    var poured = gPourAll(unit._faces ? unit._faces() : [], 'in');
    gSwell(btn);
    function done() { unit._busy = false; btn.removeAttribute('aria-busy'); }
    Promise.all([req, reduce ? 0 : gWait(G.pourIn * G.morphAt)]).then(function (a) {
      var res = a[0];
      gTake(res);
      if (form) unit._v = (res.items ? res.items[0] : res).variant_id;
      gSections(res.sections);
      gPaint(unit, 0, true);
      announce(name + ' added to your bag.');
      track('sunburn_add_to_bag', { place: placeOf(btn), variant_ids: String(unit._v), items: 1, ok: true });
      document.dispatchEvent(new CustomEvent('k:added', { detail: { btn: src || btn } }));
      return poured;
    }).then(function () {
      gImpact(btn);
      gPaintAll();
      done();
      setTimeout(function () { if (gQty(unit)) gOpenStepper(unit); }, reduce ? 0 : G.stepper.delay);
    }).catch(function (err) {
      /* not added (sold out, limit, offline): the copy comes back out and the button shakes */
      announce((err && (err.description || err.message)) || 'We could not add this to your bag. Check your connection and try again.');
      track('sunburn_add_to_bag', { place: placeOf(btn), variant_ids: String(vid), items: 1, ok: false });
      poured.then(function () { gShake(btn); return gPourAll(unit._faces ? unit._faces() : [], 'out'); }).then(done);
    });
  }

  function gChange(unit, d) {
    var v = gActive(unit), btn = unit._btn;
    if (!v || unit._busy) return;
    var m = gCart[v];
    m.q = Math.max(0, m.q + d);
    gPaint(unit, d, true);
    if (!reduce) gPlay(btn, gSim([{ from: gFrom(btn), to: 1, k: G.release.k, c: G.release.c }, { from: 0, to: 0, k: G.nudge.k, c: G.nudge.c, v: G.nudge.kick * (d > 0 ? 1 : 0.8) }]), function (s, q) { return gBt(s, q, gWide(btn)); });
    var name = btn.dataset.kName || 'Item';
    announce(m.q ? name + ': ' + m.q + ' in your bag.' : name + ' removed from your bag.');
    track('sunburn_card_qty', { place: placeOf(btn), change: d, quantity: m.q });
    gQueue(unit, v);
    gSyncTwins(unit);
    if (m.q > 0) { gOpenStepper(unit); return; }
    /* last one out: the button turns back to Add and a copy comes back out of it */
    unit.classList.remove('is-open');
    if (unit._st && unit._st.contains(document.activeElement)) btn.focus({ preventScroll: true });
    if (reduce) return;
    unit._busy = true; btn.setAttribute('aria-busy', 'true');
    setTimeout(function () {
      gPourAll(unit._faces ? unit._faces() : [], 'out').then(function () {
        var land = unit._land && unit._land();
        if (land) gPlay(land, gSim([{ from: 1, to: 1, k: G.land.k, c: G.land.c, v: G.land.kick }]), function (s) { return { transform: 'scale(' + s.toFixed(4) + ')' }; });
        unit._busy = false; btn.removeAttribute('aria-busy');
      });
    }, 60);
  }
  /* other units showing the same product (product page button and its sticky bar) follow at once */
  function gSyncTwins(unit) {
    document.querySelectorAll('[data-k-gu]').forEach(function (u) { if (u !== unit && !u._busy && u._btn) gPaint(u); });
  }
  /* quantity changes are sent once taps pause (260 ms), one request at a time per unit */
  function gQueue(unit, v) {
    clearTimeout(unit._qt);
    unit._qt = setTimeout(function () {
      unit._qt = null;
      var want = gCart[v].q, key = gCart[v].key;
      unit._chain = (unit._chain || Promise.resolve()).then(function () {
        return gPost(G_CHANGE(), { id: key, quantity: want });
      }).then(function (cart) {
        var mine = gCart[v] && gCart[v].q;
        gRebuild(cart);
        if (unit._qt) gCart[v] = Object.assign(gCart[v] || { key: key }, { q: mine }); /* newer taps are still waiting */
        gSections(cart.sections);
        gPaintAll();
      }).catch(function (err) {
        announce((err && err.description) || 'We could not update your bag. Check your connection and try again.');
        return gFetch();
      });
    }, 260);
  }

  /* ---- groups and drawer rows: pour, catch, Added ---- */
  function gGroupFaces(btn) {
    var row = btn.closest('.k-cd-btn');
    if (row) return [{ host: row.parentElement, face: row.parentElement.firstElementChild, btn: btn }];
    var kit = btn.closest('.k-sm-k');
    if (kit) return [{ host: kit, face: kit.querySelector('.k-sm-kc'), btn: btn }];
    var box = btn.closest('[data-k-fbt]') || btn.closest('.k-wd');
    if (!box) return [];
    var imgs = box.matches('.k-wd') ? box.querySelectorAll('[data-k-wd-item] img') : box.querySelectorAll('li input:checked');
    return Array.prototype.slice.call(imgs, 0, 5).map(function (x) {
      var img = x.tagName === 'IMG' ? x : x.closest('li').querySelector('img');
      return img ? { img: img, btn: btn, z: box.matches('.k-wd') ? 9999 : 0 } : null; /* above the Saved drawer */
    }).filter(Boolean);
  }
  function gGroup(btn) {
    var ids = (btn.dataset.kAdd || '').split(',').filter(Boolean);
    if (!ids.length || btn._gbusy) return;
    btn._gbusy = true;
    var drawer = document.querySelector('cart-drawer');
    var toDrawer = !!btn.closest('cart-drawer, .k-wd') && drawer && typeof drawer.renderContents === 'function';
    var iconOnly = btn.hasAttribute('data-k-icon');
    if (btn.dataset.kLabel == null) btn.dataset.kLabel = btn.textContent;
    var say = function (t) { if (!iconOnly) btn.textContent = t; };
    var what = btn.dataset.kName || (ids.length > 1 ? ids.length + ' items' : 'Item');
    btn.setAttribute('aria-busy', 'true');
    btn.classList.remove('is-in', 'is-err');
    var faces = gGroupFaces(btn);
    var poured = gPourAll(faces, 'in');
    gSwell(btn);
    var req = gPost(G_ADD(), { items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) });
    function done() { btn._gbusy = false; btn.removeAttribute('aria-busy'); }
    Promise.all([req, poured]).then(function (a) {
      var res = a[0];
      gTake(res);
      gImpact(btn);
      btn.classList.add('is-in');
      say(btn.dataset.kAdded || 'Added ✓');
      announce(what + ' added to your bag.');
      track('sunburn_add_to_bag', { place: placeOf(btn), variant_ids: ids.join(','), items: ids.length, ok: true });
      document.dispatchEvent(new CustomEvent('k:added', { detail: { btn: btn } }));
      if (toDrawer) { drawer.classList.remove('is-empty'); drawer.renderContents({ id: ids[0], sections: res.sections }); }
      else gSections(res.sections);
      gPaintAll();
      done();
      setTimeout(function () { btn.classList.remove('is-in'); say(btn.dataset.kLabel); }, 2600);
    }).catch(function (err) {
      announce(((err && (err.description || err.message)) || 'We could not add this to your bag.') + ' Check the item and try again.');
      track('sunburn_add_to_bag', { place: placeOf(btn), variant_ids: ids.join(','), items: ids.length, ok: false });
      btn.classList.add('is-err');
      say('Not added. Try again');
      poured.then(function () { gShake(btn); return gPourAll(faces, 'out'); }).then(done);
      setTimeout(function () { btn.classList.remove('is-err'); say(btn.dataset.kLabel); }, 4000);
    });
  }

  /* ---- registering units ---- */
  function gUnit(unit, btn, o) {
    if (unit._btn === btn && unit._st && unit.contains(unit._st)) return;
    unit.setAttribute('data-k-gu', '');
    btn.setAttribute('data-k-gb', '');
    unit._btn = btn;
    Object.keys(o).forEach(function (k) { unit['_' + k] = o[k]; });
    /* position: relative for static units and pill buttons comes from sunburn.css (:where, so a set position wins) */
    if (o.pill) {
      btn.classList.add('k-gpill');
      if (!btn.querySelector('.k-gp')) {
        var gp = document.createElement('span');
        gp.className = 'k-gp'; gp.setAttribute('aria-hidden', 'true');
        gp.innerHTML = '<span class="k-g-in">' + G_CART + '<text x="13.3" y="14.3" text-anchor="middle" font-size="10" fill="currentColor">1</text>' + G_WHEELS + '</span><span class="k-gp-t">In your bag</span><span class="k-gp-s">In bag</span>';
        btn.appendChild(gp);
      }
    } else if (!btn.querySelector('.k-g-add')) btn.innerHTML = G_ICONS;
    var st = unit.querySelector(':scope > .k-gs');
    if (!st) {
      var nm = btn.dataset.kName || '';
      st = document.createElement('div');
      st.className = 'k-gs'; st.setAttribute('role', 'group'); st.setAttribute('aria-label', 'Quantity of ' + nm + ' in your bag');
      st.innerHTML = '<button type="button" data-k-gd="-1" aria-label="One less ' + nm + '"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 12h12"/></svg></button>'
        + '<span class="k-gs-n k-n" aria-live="polite"><span>0</span></span>'
        + '<button type="button" data-k-gd="1" aria-label="One more ' + nm + '"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 6v12M6 12h12"/></svg></button>';
      unit.appendChild(st);
    }
    unit._st = st;
    if (gCart) gPaint(unit);
  }
  function gRegister(root) {
    root = root || document;
    /* product cards (the stepper and icons come from the snippet) */
    root.querySelectorAll('[data-k-card]').forEach(function (card) {
      var b = card.querySelector('button.k-nc-cart');
      if (!b || b.disabled || !card.querySelector('.k-gs')) return;
      gUnit(card, b, { faces: function () { return [{ host: card, face: card.querySelector('.k-nc-card'), btn: b }]; }, land: function () { return card.querySelector('.k-nc-card'); } });
    });
    /* steps plates, the kit card, reel docks: one product each */
    root.querySelectorAll('.k-sm-t .k-sm-cart[data-k-add], .k-sm-k:not(.k-sm-all) .k-sm-cart[data-k-add], .k-rl-cart[data-k-add]').forEach(function (b) {
      if (b.disabled || (b.dataset.kAdd || '').indexOf(',') > -1) return;
      var unit = b.closest('.k-sm-t, .k-sm-k, .k-rl-dock'), face = unit && unit.querySelector('.k-sm-card, .k-sm-kc, .k-rl-face');
      if (!unit || !face) return;
      unit.dataset.kVariants = b.dataset.kAdd;
      gUnit(unit, b, { pill: !b.hasAttribute('data-k-icon'), faces: function () { return [{ host: unit, face: face, btn: b }]; }, land: function () { return face; } });
    });
    /* ingredients page formula labels: the pack photo pours into Add to bag */
    root.querySelectorAll('.k-igl-cta [data-k-add]').forEach(function (b) {
      var unit = b.closest('.k-igl-p');
      if (b.disabled || !unit) return;
      unit.dataset.kVariants = b.dataset.kAdd;
      var photo = function () { return unit.querySelector('.k-igl-ph img'); };
      gUnit(unit, b, { pill: true, faces: function () { var p = photo(); return p ? [{ img: p, btn: b }] : []; }, land: photo });
    });
    /* the product page: its gallery photo pours into Add to bag */
    root.querySelectorAll('product-form .product-form__submit').forEach(function (b) {
      var form = b.form, unit = b.closest('.product-form__buttons'), sec = b.closest('.shopify-section') || b.closest('section');
      if (!form || !unit || !sec) return;
      if (!b.dataset.kName) { var h = sec.querySelector('.product__title h1, .product__title h2, h1'); b.dataset.kName = h ? h.textContent.trim() : 'Item'; }
      var photo = function () { return sec.querySelector('.product__media-item.is-active img') || sec.querySelector('.product__media img'); };
      gUnit(unit, b, { pill: true, form: form, root: sec, getV: function () { var i = form.querySelector('[name=id]'); return i ? i.value : ''; },
        faces: function () { var p = photo(); return p ? [{ img: p, btn: b, z: 2 }] : []; }, land: photo }); /* z 2: under the sticky header (3) */
    });
    /* the product page's sticky bar: same product, its own thumbnail */
    document.querySelectorAll('[data-k-sticky]').forEach(function (bar) {
      var b = bar.querySelector('[data-k-sticky-add]'), form = document.getElementById('product-form-' + bar.dataset.kSticky);
      if (!b || !form) return;
      if (!b.dataset.kName) { var t = bar.querySelector('.k-sticky-t'); b.dataset.kName = t ? t.textContent.trim() : 'Item'; }
      var thumb = function () { return bar.querySelector('.k-sticky-img img'); };
      gUnit(bar, b, { pill: true, form: form, getV: function () { var i = form.querySelector('[name=id]'); return i ? i.value : ''; },
        faces: function () { var p = thumb(); return p ? [{ img: p, btn: b }] : []; }, land: thumb });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-k-gb], .k-nc-opt[data-k-ga], .k-gs [data-k-gd]');
    if (!t) return;
    var unit = t.closest('[data-k-gu]') || (t.classList.contains('k-nc-opt') ? t.closest('[data-k-card]') : null);
    if (!unit || !unit._btn) return;
    var stop = function () { e.preventDefault(); e.stopPropagation(); };
    if (t.hasAttribute('data-k-gd')) { stop(); gChange(unit, parseInt(t.dataset.kGd, 10)); return; }
    if (t.classList.contains('k-nc-opt')) {
      if (t.closest('.k-nc-sheet.is-buy')) return; /* buy mode: cardClick sends it to checkout */
      stop(); closeSheet(unit, true); gAdd(unit, t.dataset.kGa, t); return;
    }
    if (t.disabled) return;
    if (unit._busy) { stop(); return; }
    if (unit.matches('[data-k-sticky]')) track('sunburn_sticky_click', { action: 'add_to_bag' });
    if (gQty(unit)) { stop(); gChange(unit, -1); return; }
    if (unit._form) { stop(); gAdd(unit, unit._getV(), t); return; }
    var id = t.dataset.kGa || t.dataset.kAdd;
    if (id) { stop(); gAdd(unit, id, t); }
    /* several packs and none in the bag yet: the pack sheet opens as before */
  }, true);
  window.addEventListener('resize', function () { document.querySelectorAll('[data-k-gu].is-open').forEach(gPlace); });
  /* desktop: hovering the cart brings the pill back */
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var b = e.target.closest('[data-k-gb], .k-gs'), unit = b && b.closest('[data-k-gu]');
    if (!unit || (b !== unit._btn && b !== unit._st)) return;
    clearTimeout(unit._lt);
    if (!unit._busy && gQty(unit)) gOpenStepper(unit);
  });
  /* desktop: leaving both the cart and the pill hides the pill at once */
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var unit = e.target.closest('[data-k-gu]');
    if (!unit || !unit._st || !unit.classList.contains('is-open')) return;
    var inside = function (n) { return !!n && n.nodeType === 1 && (unit._btn.contains(n) || unit._st.contains(n)); };
    if (!inside(e.target) || inside(e.relatedTarget)) return;
    clearTimeout(unit._lt);
    unit._lt = setTimeout(function () { if (!unit._busy && !gHeld(unit)) gCloseStepper(unit, true); }, 60);
  });

  function initGenie(root) {
    gRegister(root);
    if (!gLoad) {
      gLoad = gFetch().catch(function () {});
      /* the cart changed somewhere else (drawer, another tab's add): follow it */
      var bub = document.getElementById('cart-icon-bubble'), t;
      if (bub && 'MutationObserver' in window) new MutationObserver(function () {
        if (Date.now() - gSelfAt < 600) return;
        clearTimeout(t); t = setTimeout(function () { gFetch().catch(function () {}); }, 250);
      }).observe(bub, { childList: true, subtree: true, characterData: true });
      /* collection/search filters and sort swap the grid's HTML (facets.js): wire the new cards */
      var grid = document.getElementById('ProductGridContainer'), gt;
      if (grid && 'MutationObserver' in window) new MutationObserver(function () {
        clearTimeout(gt); gt = setTimeout(function () { gRegister(grid); gPaintAll(); initSaved(grid); bandsSync(); }, 30);
      }).observe(grid, { childList: true });
      /* the product page switched pack: its button shows that pack's count */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { gRegister(document); gPaintAll(); }, 30); });
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { if (Date.now() - gSelfAt > 600) gFetch().catch(function () {}); });
      }
    }
  }
  function saved() { return store('k_saved') || []; }
  function cardClick(e) {
    var other = document.querySelector('[data-k-card] .k-nc-sheet:not([hidden])');
    if (other && !other.closest('[data-k-card]').contains(e.target)) closeSheet(other.closest('[data-k-card]'));
    var buyOpt = e.target.closest('.k-nc-sheet.is-buy .k-nc-opt[data-k-ga]');
    if (buyOpt) { e.preventDefault(); if (!buyOpt.disabled) buyNow(buyOpt.dataset.kGa, buyOpt); return true; }
    var buy = e.target.closest('[data-k-buy]');
    if (buy) {
      e.preventDefault();
      if (!buy.hasAttribute('data-k-buy-sheet')) { buyNow(buy.dataset.kBuy, buy); return true; }
      var bc = buy.closest('[data-k-card]'), bs = sheetOf(bc);
      if (!bs) return true;
      var wasBuy = !bs.hidden && bs.classList.contains('is-buy');
      closeSheet(bc);
      document.querySelectorAll('[data-k-card] .k-nc-sheet:not([hidden])').forEach(function (x) { closeSheet(x.closest('[data-k-card]')); });
      if (wasBuy) return true;
      bs.classList.add('is-buy');
      bs.hidden = false;
      buy.setAttribute('aria-expanded', 'true');
      var bf = bs.querySelector('.k-nc-opt:not([disabled])');
      if (bf) bf.focus({ preventScroll: true });
      track('sunburn_pack_sheet_open', { place: placeOf(buy), mode: 'buy_now' });
      return true;
    }
    var open = e.target.closest('[data-k-sheet]');
    if (open) {
      var card = open.closest('[data-k-card]'), sh = sheetOf(card);
      if (!sh) return true;
      if (!sh.hidden && sh.classList.contains('is-buy')) closeSheet(card);
      if (!sh.hidden) { closeSheet(card); return true; }
      document.querySelectorAll('[data-k-card] .k-nc-sheet:not([hidden])').forEach(function (x) { closeSheet(x.closest('[data-k-card]')); });
      sh.hidden = false;
      open.setAttribute('aria-expanded', 'true');
      var first = sh.querySelector('.k-nc-opt:not([disabled])');
      if (first) first.focus({ preventScroll: true });
      track('sunburn_pack_sheet_open', { place: placeOf(open) });
      return true;
    }
    var x = e.target.closest('[data-k-sheet-close]');
    if (x) { closeSheet(x.closest('[data-k-card]'), true); return true; }
    var heart = e.target.closest('[data-k-save]');
    if (heart) {
      var h = heart.dataset.kSave, list = saved(), on = list.indexOf(h) === -1;
      list = list.filter(function (v) { return v !== h; });
      if (on) list.push(h);
      store('k_saved', list);
      document.querySelectorAll('[data-k-save]').forEach(function (b) {
        if (b.dataset.kSave === h) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      wishCount();
      if (on) wishPop();
      announce(on ? 'Saved to your list.' : 'Removed from your list.');
      track('sunburn_save_toggle', { saved: on });
      document.dispatchEvent(new CustomEvent('k:saved', { detail: { handle: h, on: on, btn: heart } }));
      return true;
    }
    return false;
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var sh = document.querySelector('[data-k-card] .k-nc-sheet:not([hidden])');
    if (sh) closeSheet(sh.closest('[data-k-card]'), true);
  });
  function initSaved(root) {
    var list = saved();
    root.querySelectorAll('[data-k-save]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.dataset.kSave) !== -1 ? 'true' : 'false');
    });
  }

  /* ---- wishlist: header heart count, and the "Saved for later" page (sections/sunburn-wishlist.liquid) ---- */
  function wishCount() {
    var n = saved().length;
    document.querySelectorAll('[data-k-wish-count]').forEach(function (c) {
      c.textContent = n > 99 ? '99+' : n;
      c.hidden = !n;
    });
    document.querySelectorAll('[data-k-wish-open]').forEach(function (a) {
      a.classList.toggle('has-items', n > 0);
      a.setAttribute('aria-label', n ? 'Saved products, ' + n + (n === 1 ? ' item' : ' items') : 'Saved products');
    });
  }
  /* the header heart answers the card heart, so shoppers learn where saved things went */
  function wishPop() {
    if (reduce) return;
    document.querySelectorAll('[data-k-wish-open]').forEach(function (a) {
      a.classList.remove('is-pop');
      void a.offsetWidth;
      a.classList.add('is-pop');
    });
  }
  /* another tab changed the list */
  window.addEventListener('storage', function (e) {
    if (e.key !== 'k_saved') return;
    wishCount();
    initSaved(document);
  });

  /* saved drawer (snippets/sunburn-wish-drawer.liquid): opened by the header heart */
  function initWish() {
    var wd = document.querySelector('[data-k-wd]');
    if (!wd || wd.dataset.kInit) return;
    wd.dataset.kInit = '1';
    function $(sel) { return wd.querySelector(sel); }
    var panel = $('.k-wd-panel'), list = $('[data-k-wd-list]'), has = $('[data-k-wd-has]'), none = $('[data-k-wd-none]');
    var shared = $('[data-k-wd-shared]'), toast = $('[data-k-wd-undo]'), shareBtn = $('[data-k-wd-share]');
    var all = $('.k-wd-all'), ship = $('[data-k-wd-ship]'), shareT = $('[data-k-wd-share-t]');
    var today = new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var free = parseInt(wd.dataset.free, 10) || 0;
    var rows = {}, opener = null, removed = null, toastTimer = 0, closeTimer = 0;
    var sharedList = (new URLSearchParams(location.search).get('saved') || '').split(',')
      .map(function (h) { return h.trim().toLowerCase(); })
      .filter(function (h, i, a) { return /^[a-z0-9-]+$/.test(h) && a.indexOf(h) === i; })
      .slice(0, 40);
    var isShared = sharedList.length > 0;

    function handles() { return isShared ? sharedList : saved().slice().reverse(); }
    function items() { return Array.prototype.slice.call(list.querySelectorAll('[data-k-wd-item]')); }
    function find(h) { return items().filter(function (li) { return li.dataset.kWdItem === h; })[0]; }
    function fetchRow(h) {
      return fetch(base + 'products/' + encodeURIComponent(h) + '?view=k-wish')
        .then(function (r) {
          if (r.status === 404) return { gone: true };
          return r.ok ? r.text().then(function (t) { return { html: t }; }) : {};
        })
        .catch(function () { return {}; })
        .then(function (r) {
          if (!r.html) return r;
          var t = document.createElement('template');
          t.innerHTML = r.html.trim();
          r.li = t.content.querySelector('[data-k-wd-item]');
          return r;
        });
    }
    function skeleton(h) {
      var li = document.createElement('li');
      li.className = 'k-wd-row k-wd-sk';
      li.dataset.sk = h;
      li.setAttribute('aria-hidden', 'true');
      li.innerHTML = '<span></span><div><i></i><i></i></div><div><i></i></div>';
      return li;
    }

    function refresh() {
      var its = items(), n = its.length, loading = !!list.querySelector('.k-wd-sk');
      $('[data-k-wd-n]').textContent = n ? n : '';
      $('[data-k-wd-meta]').textContent = (n ? n + (n === 1 ? ' item' : ' items') + ' \u00b7 ' : '') + today;
      has.hidden = !n && !loading;
      none.hidden = n > 0 || loading || isShared;
      shareBtn.hidden = !n || isShared;
      if (!n) return;
      /* one money format down the whole bill: line prices match the totals */
      its.forEach(function (li) {
        li.querySelector('[data-k-wd-now]').textContent = money(+li.dataset.price);
        li.querySelector('[data-k-wd-was] span:last-child').textContent = money(+li.dataset.mrp);
      });
      var av = its.filter(function (li) { return li.hasAttribute('data-avail'); });
      var tot = 0, mrp = 0;
      av.forEach(function (li) { tot += +li.dataset.price || 0; mrp += +li.dataset.mrp || 0; });
      $('[data-k-wd-mrp]').textContent = money(mrp);
      $('[data-k-wd-save]').textContent = '\u2212' + money(mrp - tot);
      $('[data-k-wd-total]').textContent = money(tot);
      if (ship) {
        ship.classList.toggle('k-wd-disc', tot >= free);
        ship.textContent = tot >= free ? 'Free' : money(free - tot) + ' away from free';
      }
      all.dataset.kAdd = av.map(function (li) { return li.dataset.v; }).join(',');
      all.dataset.kName = av.length === 1 ? av[0].dataset.title : av.length + ' saved products';
      all.disabled = !av.length;
      $('[data-k-wd-all-price]').textContent = av.length ? money(tot) : '';
    }

    /* rows are kept once fetched, so reopening is instant; only new handles hit the network */
    function render() {
      var hs = handles();
      list.innerHTML = '';
      hs.forEach(function (h) { list.appendChild(rows[h] || skeleton(h)); });
      initSaved(list);
      refresh();
      var missing = hs.filter(function (h) { return !rows[h]; });
      if (!missing.length) return;
      Promise.all(missing.map(fetchRow)).then(function (res) {
        var fix = {}, changed = false;
        res.forEach(function (r, i) {
          var h = missing[i], sk = list.querySelector('[data-sk="' + h + '"]');
          if (r.li) {
            rows[r.li.dataset.kWdItem] = r.li;
            if (sk) sk.replaceWith(r.li);
            /* handle renamed (Shopify redirected): keep the list in step with the row's heart */
            if (r.li.dataset.kWdItem !== h) { fix[h] = r.li.dataset.kWdItem; changed = true; }
          } else {
            if (sk) sk.remove();
            if (r.gone) { fix[h] = null; changed = true; }
          }
        });
        if (changed && !isShared) {
          store('k_saved', saved().map(function (h) { return h in fix ? fix[h] : h; }).filter(Boolean));
          wishCount();
        }
        initSaved(list);
        refresh();
      });
    }

    function open(from) {
      clearTimeout(closeTimer);
      opener = from || null;
      wd.hidden = false;
      void wd.offsetWidth;
      wd.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
      document.querySelectorAll('[data-k-wish-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      render();
      var first = $('.k-wd-close');
      if (typeof window.trapFocus === 'function') window.trapFocus(panel, first);
      else first.focus();
      track('sunburn_wishlist_open', { items: handles().length, shared: isShared });
    }
    function close(refocus) {
      if (wd.hidden) return;
      wd.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
      document.querySelectorAll('[data-k-wish-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var back = refocus === false ? null : opener;
      if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(back);
      else if (back) back.focus();
      /* a shared list is a one-time view: closing it returns the drawer to the shopper's own list */
      if (isShared) dropShared();
      closeTimer = setTimeout(function () { wd.hidden = true; hideToast(); }, reduce ? 0 : 420);
    }
    function dropShared() {
      isShared = false;
      shared.hidden = true;
      var u = new URL(location.href);
      u.searchParams.delete('saved');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    }

    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-k-wish-open]');
      if (o) { e.preventDefault(); open(o); return; }
      if (e.target.closest('[data-k-wd-close]')) { close(); return; }
      var pk = e.target.closest('[data-k-wd-pack]');
      if (pk && wd.contains(pk)) {
        var li = pk.closest('[data-k-wd-item]');
        li.querySelectorAll('[data-k-wd-pack]').forEach(function (b) { b.setAttribute('aria-pressed', b === pk ? 'true' : 'false'); });
        var p = +pk.dataset.price, m = +pk.dataset.mrp;
        li.dataset.v = pk.dataset.kWdPack;
        li.dataset.price = p;
        li.dataset.mrp = m;
        li.querySelector('[data-k-wd-now]').textContent = money(p);
        li.querySelector('[data-k-wd-was] span:last-child').textContent = money(m);
        li.querySelector('[data-k-wd-was]').hidden = m <= p;
        refresh();
      }
    });
    wd.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } });
    /* something went into the bag: hand over to the cart drawer */
    document.addEventListener('k:added', function (e) {
      if (!wd.hidden && e.detail && e.detail.btn && wd.contains(e.detail.btn)) close(false);
    });

    function hideToast() { toast.hidden = true; removed = null; }
    function removeRow(li) {
      li.classList.add('is-out');
      setTimeout(function () {
        if (!li.parentNode) return;
        var refocus = li.contains(document.activeElement);
        removed = { li: li, next: li.nextElementSibling, handle: li.dataset.kWdItem };
        li.classList.remove('is-out');
        li.remove();
        refresh();
        $('[data-k-wd-undo-t]').textContent = 'Removed ' + (li.dataset.title || 'product') + '.';
        toast.hidden = false;
        clearTimeout(toastTimer);
        toastTimer = setTimeout(hideToast, 6000);
        if (refocus) $('[data-k-wd-undo-btn]').focus({ preventScroll: true });
      }, reduce ? 0 : 240);
    }
    document.addEventListener('k:saved', function (e) {
      if (isShared) return;
      var h = e.detail.handle, li = find(h);
      if (!e.detail.on) { if (li && !wd.hidden) removeRow(li); else if (li) li.remove(); return; }
      if (!wd.hidden && !li) render();
    });
    $('[data-k-wd-undo-btn]').addEventListener('click', function () {
      if (!removed) return;
      var r = removed;
      store('k_saved', saved().filter(function (x) { return x !== r.handle; }).concat(r.handle));
      list.insertBefore(r.li, r.next && r.next.parentNode === list ? r.next : null);
      initSaved(list);
      wishCount();
      refresh();
      hideToast();
      var heart = r.li.querySelector('[data-k-save]');
      if (heart) heart.focus({ preventScroll: true });
      announce('Back in your list.');
      track('sunburn_wishlist_undo', {});
    });

    $('[data-k-wd-share]').addEventListener('click', function () {
      var hs = items().map(function (li) { return li.dataset.kWdItem; });
      var url = location.origin + base + '?saved=' + hs.join(',');
      track('sunburn_wishlist_share', { items: hs.length });
      if (navigator.share && matchMedia('(pointer: coarse)').matches) {
        navigator.share({ title: 'My saved list · ' + wd.dataset.shop, url: url }).catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          shareT.hidden = false;
          announce('Link to your list copied.');
          setTimeout(function () { shareT.hidden = true; }, 2200);
        }, function () {});
      }
    });

    if (isShared) {
      shared.hidden = false;
      $('[data-k-wd-shared-n]').textContent = sharedList.length + (sharedList.length === 1 ? ' product' : ' products') + ' someone picked for you.';
      $('[data-k-wd-keep]').addEventListener('click', function () {
        var mine = saved();
        sharedList.forEach(function (h) { if (mine.indexOf(h) === -1) mine.push(h); });
        store('k_saved', mine);
        dropShared();
        wishCount();
        wishPop();
        announce('Saved to your list.');
        track('sunburn_wishlist_keep_shared', { items: sharedList.length });
        render();
      });
      open(null);
    }
  }

  /* ================= conversion: product page, collection, sitewide ================= */
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    var v = cents / 100;
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur, maximumFractionDigits: v % 1 ? 2 : 0 }).format(v);
    } catch (e) { return '₹' + v; }
  }
  function store(key, val) {
    try {
      if (arguments.length > 1) localStorage.setItem(key, JSON.stringify(val));
      else return JSON.parse(localStorage.getItem(key) || 'null');
    } catch (e) { return null; }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* pincode → estimated delivery window. Dispatch Mon–Sat; after the cut-off it moves to the next working day. */
  function initPin(root) {
    root.querySelectorAll('[data-k-pin]').forEach(function (box) {
      if (box.dataset.kInit) return;
      box.dataset.kInit = '1';
      var form = box.querySelector('form');
      var input = box.querySelector('input');
      var eta = box.querySelector('[data-k-eta] span');
      if (eta && !eta.id) { eta.id = 'k-eta-' + Math.random().toString(36).slice(2, 8); input.setAttribute('aria-describedby', eta.id); }
      var cutoff = parseInt(box.dataset.cutoff, 10) || 14;
      var lo = parseInt(box.dataset.min, 10) || 3;
      var hi = parseInt(box.dataset.max, 10) || 7;
      function istNow() { var d = new Date(); return new Date(d.getTime() + (330 + d.getTimezoneOffset()) * 60000); }
      function plus(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
      function fmt(d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }
      function check(pin, quiet) {
        if (!/^[1-9][0-9]{5}$/.test(pin)) {
          if (!quiet) {
            box.classList.remove('is-checked');
            box.classList.add('is-bad');
            input.setAttribute('aria-invalid', 'true');
            eta.textContent = pin.length < 6 ? 'Pincode is 6 digits. Check the number and try again.' : 'Pincodes do not start with 0. Check the number and try again.';
            input.focus();
            track('sunburn_pincode_check', { valid: false });
          }
          return;
        }
        box.classList.remove('is-bad');
        input.removeAttribute('aria-invalid');
        var now = istNow();
        var ship = new Date(now);
        var today = now.getDay() !== 0 && now.getHours() < cutoff;
        if (!today) ship = plus(ship, 1);
        while (ship.getDay() === 0) ship = plus(ship, 1);
        eta.innerHTML = 'Delivery to <b>' + pin + '</b> by <b>' + fmt(plus(ship, lo)) + ' – ' + fmt(plus(ship, hi)) + '</b> <small>(estimate)</small>' +
          (today ? '<br><small>Order before ' + (cutoff > 12 ? cutoff - 12 + ' pm' : cutoff + ' am') + ' to dispatch today</small>' : '');
        box.classList.add('is-checked');
        if (!quiet) track('sunburn_pincode_check', { valid: true, dispatch_today: today });
        store('k-pin', pin);
      }
      input.addEventListener('input', function () {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
        if (box.classList.contains('is-bad')) { box.classList.remove('is-bad'); input.removeAttribute('aria-invalid'); }
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); check(input.value.trim()); });
      var saved = store('k-pin');
      if (saved) { input.value = saved; check(saved, true); }
    });
  }

  /* offer countdown — only rendered when the merchant sets an end time; hides itself once it passes */
  function initDeals(root) {
    root.querySelectorAll('[data-k-ends]').forEach(function (el) {
      if (el.dataset.kInit) return;
      el.dataset.kInit = '1';
      var end = Date.parse(el.dataset.kEnds);
      var out = el.querySelector('[data-k-left]');
      if (isNaN(end)) return;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var s = Math.floor((end - Date.now()) / 1000);
        if (s <= 0) { el.hidden = true; clearInterval(t); return; }
        var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
        out.textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s % 60);
        el.hidden = false;
      }
      var t = setInterval(tick, 1000);
      tick();
    });
  }

  /* stock urgency badge: always counts down to the next dispatch cut-off (IST, Mon–Sat, as the pincode check).
     One shared ticker reads the badge each second, so it keeps working after a variant swaps the badge's HTML. */
  var urgT;
  function initUrg() {
    if (urgT || !document.querySelector('[data-k-urg]')) return;
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var d = new Date();
      var now = new Date(d.getTime() + (330 + d.getTimezoneOffset()) * 60000);
      document.querySelectorAll('[data-k-urg]').forEach(function (b) {
        var ship = b.querySelector('[data-k-urg-ship]');
        var txt = b.querySelector('[data-k-urg-txt]');
        if (!ship || !txt) return;
        var cut = parseInt(b.dataset.kUrg, 10) || 14;
        /* the next cut-off: today's if it has not passed (and it is not Sunday), else the next working day's */
        var end = new Date(now); end.setHours(cut, 0, 0, 0);
        if (now.getDay() === 0 || end <= now) {
          do { end.setDate(end.getDate() + 1); } while (end.getDay() === 0);
        }
        var s = Math.floor((end - now) / 1000);
        var dd = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
        var left = dd ? dd + 'd ' + h + 'h ' + pad(m) + 'm' : (h ? h + 'h ' + pad(m) + 'm ' : m + 'm ') + pad(s % 60) + 's';
        var day0 = new Date(now); day0.setHours(0, 0, 0, 0);
        var gap = Math.round((new Date(end).setHours(0, 0, 0, 0) - day0) / 86400000);
        /* phones show the weekday instead of "tomorrow" so the low-stock badge stays on one line */
        var when = gap === 0 ? 'today' : gap === 1 ? '<span class="k-urg-long">tomorrow</span><span class="k-urg-short">' + days[end.getDay()] + '</span>' : days[end.getDay()];
        var html = '<span class="k-urg-long">Order in </span><b>' + left + '</b> to ship ' + when;
        b.classList.toggle('is-today', gap === 0);
        if (txt.innerHTML !== html) txt.innerHTML = html;
        ship.hidden = false;
      });
    }
    urgT = setInterval(tick, 1000);
    tick();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(tick, 0); });
    }
  }

  /* frequently bought together — totals and the add button follow the ticked boxes */
  function syncFbt(box) {
    var boxes = box.querySelectorAll('input[type=checkbox]');
    var ids = [], total = 0, mrp = 0;
    boxes.forEach(function (c) {
      if (!c.checked) return;
      ids.push(c.dataset.id);
      total += parseInt(c.dataset.price, 10) || 0;
      mrp += parseInt(c.dataset.mrp, 10) || 0;
    });
    var btn = box.querySelector('[data-k-add]');
    btn.dataset.kAdd = ids.join(',');
    btn.textContent = ids.length > 1 ? 'Add all ' + ids.length + ' to bag' : 'Add to bag';
    btn.dataset.kLabel = btn.textContent;
    btn.dataset.kName = ids.length > 1 ? ids.length + ' items' : 'Item';
    box.querySelector('[data-k-total]').textContent = money(total);
    box.querySelector('[data-k-mrp]').textContent = mrp > total ? money(mrp) : '';
    box.querySelector('[data-k-saved]').textContent = mrp > total ? 'Save ' + money(mrp - total) : '';
  }
  function initFbt(root) {
    root.querySelectorAll('[data-k-fbt]').forEach(function (box) {
      if (box.dataset.kInit) return;
      box.dataset.kInit = '1';
      box.addEventListener('change', function () { syncFbt(box); });
      syncFbt(box);
    });
  }

  /* sticky buy bar — shows whenever the real Add to cart button is out of view */
  function initSticky(root) {
    root.querySelectorAll('[data-k-sticky]').forEach(function (bar) {
      if (bar.dataset.kInit) return;
      bar.dataset.kInit = '1';
      var sid = bar.dataset.kSticky;
      var main = document.getElementById('ProductSubmitButton-' + sid);
      if (!main) return;
      /* escape the sticky info column so position: fixed is relative to the viewport;
         drop any bar left behind by an earlier theme-editor reload */
      document.querySelectorAll('body > .k-sticky').forEach(function (old) { if (old !== bar) old.remove(); });
      document.body.appendChild(bar);
      function show(on) {
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
        document.body.classList.toggle('k-has-sticky', on);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          show(!es[0].isIntersecting);
        }).observe(main);
      }
      /* Add to bag is taken by the Genie engine (it posts the main form) */
      bar.querySelector('[data-k-sticky-buy]').addEventListener('click', function () {
        var form = document.getElementById('product-form-' + sid);
        var id = form && form.querySelector('[name=id]') ? form.querySelector('[name=id]').value : '';
        var q = document.getElementById('Quantity-' + sid);
        var qty = Math.max(1, parseInt(q && q.value, 10) || 1);
        track('sunburn_sticky_click', { action: 'buy_now' });
        if (id) window.location.href = ((window.routes && window.routes.cart_url) || '/cart') + '/' + id + ':' + qty;
      });
    });
  }

  /* keep the sticky bar and the bundle's "this item" row on the selected variant */
  function onVariant(v) {
    if (!v) return;
    document.querySelectorAll('[data-k-atc-price]').forEach(function (el) { el.dataset.unit = v.price; });
    syncAtcPrice();
    syncOffers();
    var pct = v.compare_at_price > v.price ? Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
    document.querySelectorAll('[data-k-media-off]').forEach(function (el) { el.hidden = !pct; el.textContent = pct + '% off'; });
    document.querySelectorAll('.k-sticky').forEach(function (bar) {
      bar.querySelector('[data-k-sticky-price]').textContent = money(v.price);
      var mrp = bar.querySelector('[data-k-sticky-mrp]'), off = bar.querySelector('[data-k-sticky-pct]');
      mrp.hidden = off.hidden = !pct;
      mrp.textContent = pct ? money(v.compare_at_price) : '';
      off.textContent = pct ? pct + '% off' : '';
      bar.querySelectorAll('button').forEach(function (b) { b.disabled = !v.available; });
    });
    document.querySelectorAll('[data-k-fbt]').forEach(function (box) {
      var cur = box.querySelector('[data-k-current]');
      if (!cur) return;
      cur.dataset.id = v.id;
      cur.dataset.price = v.price;
      cur.dataset.mrp = v.compare_at_price || v.price;
      var p = box.querySelector('[data-k-current-price]');
      if (p) p.textContent = money(v.price);
      syncFbt(box);
    });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) { onVariant(e && e.data && e.data.variant); });
  }

  /* offer codes: copy to the clipboard; with data-k-apply the code is also put on the shopper's
     checkout through Shopify's /discount/<code> link (it sets the session's discount cookie) */
  function copyText(t) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t);
    return new Promise(function (ok, no) {
      var ta = document.createElement('textarea');
      ta.value = t; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? ok() : no(); } catch (e) { no(e); }
      ta.remove();
    });
  }
  /* offer coupons ([data-k-coupon], snippets/sunburn-offer-tile.liquid): copy the code; with
     data-k-apply also put it on the shopper's checkout through Shopify's /discount/<code> link,
     which sets the session's discount cookie. The button stays green while that code is applied. */
  /* Shopify's discount cookie isn't always readable from script, so the code applied in this
     browser session is remembered as well */
  function appliedCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (m) return decodeURIComponent(m[1]).toUpperCase();
    try { return (sessionStorage.getItem('k-coupon') || '').toUpperCase(); } catch (e) { return ''; }
  }
  function markCoupons() {
    var cur = appliedCode();
    document.querySelectorAll('[data-k-coupon]').forEach(function (b) {
      var on = !!cur && cur === b.dataset.kCoupon.toUpperCase();
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? 'Code ' + b.dataset.kCoupon + ' applied. Copy it again' : 'Apply code ' + b.dataset.kCoupon));
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-k-coupon]');
    if (!btn) return;
    e.preventDefault();
    var code = btn.dataset.kCoupon;
    var done = function (applied) {
      btn.classList.add('is-on');
      btn.setAttribute('aria-pressed', 'true');
      announce(applied ? code + ' applied. It comes off at checkout, and the code is copied.' : code + ' copied. Paste it at checkout.');
    };
    copyText(code).catch(function () {});
    if (btn.hasAttribute('data-k-apply')) {
      try { sessionStorage.setItem('k-coupon', code); } catch (err) {}
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' })
        .then(function () { done(true); markCoupons(); }, function () { done(false); });
    } else {
      done(false);
    }
    track('sunburn_offer_copy', { code: code });
  });

  /* product share card: links follow the selected variant (product-info.js calls updateUrl),
     Copy link flips to "Copied", "More" opens the phone's share sheet where there is one */
  if (!customElements.get('k-share')) {
    customElements.define('k-share', class extends HTMLElement {
      connectedCallback() {
        if (this._k) return;
        this._k = 1;
        var self = this, more = this.querySelector('[data-k-sh-more]'), cp = this.querySelector('[data-k-sh-copy]');
        var msg = this.querySelector('[data-k-sh-msg]');
        if (more && navigator.share) {
          more.hidden = false;
          this.classList.add('has-native');
          more.addEventListener('click', function () {
            navigator.share({ title: document.title, text: self.dataset.text, url: self.dataset.url }).catch(function () {});
          });
        }
        if (cp) cp.addEventListener('click', function () {
          var done = function () {
            cp.classList.add('is-copied');
            if (msg) msg.textContent = 'Link copied';
            clearTimeout(cp._kT);
            cp._kT = setTimeout(function () { cp.classList.remove('is-copied'); if (msg) msg.textContent = ''; }, 1800);
          };
          copyText(self.dataset.url).then(done, function () {});
          track('sunburn_share', { via: 'copy' });
        });
        this.querySelectorAll('[data-k-sh]').forEach(function (a) {
          a.addEventListener('click', function () { track('sunburn_share', { via: a.dataset.kSh }); });
        });
      }
      updateUrl(url) {
        this.dataset.url = url;
        var u = encodeURIComponent(url), m = encodeURIComponent(this.dataset.text || '');
        var links = { wa: 'https://wa.me/?text=' + m + '%20' + u, fb: 'https://www.facebook.com/sharer/sharer.php?u=' + u, x: 'https://twitter.com/intent/tweet?text=' + m + '&url=' + u };
        this.querySelectorAll('[data-k-sh]').forEach(function (a) { a.href = links[a.dataset.kSh]; });
      }
    });
  }

  /* festive offers: the pack tile picks that pack in the variant picker and brings it into view */
  function initPackPick(root) {
    (root || document).querySelectorAll('[data-k-pack-pick]').forEach(function (btn) {
      if (btn.dataset.kInit) return;
      btn.dataset.kInit = '1';
      btn.addEventListener('click', function () {
        var info = btn.closest('product-info') || document;
        var input = Array.prototype.find.call(info.querySelectorAll('.product-form__input input[type=radio]'), function (i) { return i.value === btn.dataset.kPackPick; });
        if (!input) return;
        var label = info.querySelector('label[for="' + input.id + '"]');
        if (!input.checked && label) label.click();
        var box = input.closest('fieldset') || label;
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        track('sunburn_offer_pack', { pack: btn.dataset.kPackPick });
      });
    });
  }

  /* offer cards follow the selected pack: the pack card's corner turns green while its pack is
     chosen, and the free-delivery card counts down from the selected pack × quantity */
  function syncOffers() {
    document.querySelectorAll('[data-k-pack-pick]').forEach(function (b) {
      var info = b.closest('product-info') || document;
      var input = Array.prototype.find.call(info.querySelectorAll('.product-form__input input[type=radio]'), function (i) { return i.value === b.dataset.kPackPick; });
      var on = !!(input && input.checked);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-k-ship]').forEach(function (card) {
      var at = parseInt(card.dataset.kShip, 10) || 0;
      var info = card.closest('product-info');
      var unit = info && info.querySelector('[data-k-atc-price]');
      var q = info && info.querySelector('.quantity__input');
      if (!unit || !at) return;
      var total = (parseInt(unit.dataset.unit, 10) || 0) * Math.max(1, parseInt(q && q.value, 10) || 1);
      var left = at - total, t = card.querySelector('[data-k-ship-title]'), bar = card.querySelector('[data-k-ship-bar]');
      var sp = function (m) { return m.replace('\u20b9', '\u20b9 '); };
      if (t) t.textContent = left > 0 ? sp(money(left)) + ' to free delivery' : 'Ships free';
      if (bar) bar.style.setProperty('--w', Math.min(100, total * 100 / at) + '%');
    });
  }
  function initOffers(root) {
    syncOffers();
    markCoupons();
  }

  /* gallery chevrons over the main photo: step to the previous/next visible thumbnail (wraps),
     so Dawn's media-gallery swaps the photo and scrolls the thumbnail rail itself */
  function initGalNav(root) {
    (root || document).querySelectorAll('[data-k-gal]').forEach(function (nav) {
      if (nav.dataset.kInit) return;
      nav.dataset.kInit = '1';
      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-k-gal-step]');
        if (!btn) return;
        var rail = document.getElementById('GalleryThumbnails-' + nav.dataset.kGal);
        if (!rail) return;
        var thumbs = Array.prototype.filter.call(rail.querySelectorAll('.thumbnail'), function (t) { return t.offsetParent !== null; });
        if (thumbs.length < 2) return;
        var cur = thumbs.findIndex(function (t) { return t.hasAttribute('aria-current'); });
        var next = (Math.max(cur, 0) + parseInt(btn.dataset.kGalStep, 10) + thumbs.length) % thumbs.length;
        thumbs[next].click();
      });
    });
  }

  /* the price inside Add to bag is the selected pack × the quantity, as the hero's button shows its price */
  function syncAtcPrice() {
    document.querySelectorAll('[data-k-atc-price]').forEach(function (el) {
      var form = el.closest('product-form');
      var sid = form && form.dataset.sectionId;
      var q = sid && document.getElementById('Quantity-' + sid);
      var qty = Math.max(1, parseInt(q && q.value, 10) || 1);
      /* match the store's money format ("₹ 349") that Liquid printed first */
      if (!el.dataset.sp) el.dataset.sp = /\u20b9\s/.test(el.textContent) ? '1' : '0';
      var t = money((parseInt(el.dataset.unit, 10) || 0) * qty);
      el.textContent = el.dataset.sp === '1' ? t.replace('\u20b9', '\u20b9 ') : t;
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('quantity__input')) { syncAtcPrice(); syncOffers(); }
  });

  /* recently viewed — handles in localStorage; each card is the real product card, rendered by
     sections/sunburn-recent-card.liquid (Section Rendering API on the product URL) */
  function initRecent(root) {
    root.querySelectorAll('[data-k-recent]').forEach(function (sec) {
      if (sec.dataset.kInit) return;
      sec.dataset.kInit = '1';
      var limit = parseInt(sec.dataset.kRecent, 10) || 6;
      var cur = sec.dataset.kCurrent;
      var seen = (store('k-seen') || []).filter(function (h) { return typeof h === 'string'; });
      if (cur) store('k-seen', [cur].concat(seen.filter(function (h) { return h !== cur; })).slice(0, 12));
      var list = seen.filter(function (h) { return h !== cur; }).slice(0, limit);
      if (!list.length) return;
      var rail = sec.querySelector('[data-k-recent-rail]');
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      Promise.all(list.map(function (h) {
        return fetch(base + 'products/' + encodeURIComponent(h) + '?section_id=sunburn-recent-card')
          .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (pages) {
        var tpl = document.createElement('template');
        tpl.innerHTML = pages.join('');
        var cards = tpl.content.querySelectorAll('[data-k-card]');
        if (!cards.length) return;
        Array.prototype.forEach.call(cards, function (c) { rail.appendChild(c); });
        sec.hidden = false;
        /* the carousel and hearts are wired once the cards are in */
        rail.parentNode.setAttribute('data-k-rail', '');
        initRails(sec);
        initSaved(sec);
        initGenie(sec);
      });
    });
  }

  /* back to top — after ~1.5 screens */
  function initTop() {
    var btn = document.querySelector('[data-k-totop]');
    if (!btn || btn.dataset.kInit) return;
    btn.dataset.kInit = '1';
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { btn.hidden = window.scrollY < window.innerHeight * 1.5; ticking = false; });
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
  }

  /* FAQ "Thread": a chip asks its question, a typing beat plays, then the answer (from a <template>) lands in
     the log. Which questions get asked tells us what the page fails to answer (A-16). */
  function initThread(root) {
    root.querySelectorAll('[data-k-th]').forEach(function (sec) {
      if (sec.dataset.kInit) return;
      sec.dataset.kInit = '1';
      var log = sec.querySelector('.k-th-log'), done = sec.querySelector('.k-th-done');
      var qs = Array.prototype.slice.call(sec.querySelectorAll('.k-th-qs button'));
      var tabs = Array.prototype.slice.call(sec.querySelectorAll('.k-th-tabs button'));
      var tab = tabs.length ? tabs[0].dataset.t : '', busy = false;
      var find = sec.querySelector('.k-th-find input'), none = sec.querySelector('.k-th-none'), words = [];
      var edges = null;
      if (!log) return;
      /* FAQ page: the search box looks through every topic, in the question and its answer */
      function hay(b) {
        if (b.kHay == null) {
          var src = document.getElementById(b.dataset.a);
          b.kHay = (b.textContent + ' ' + (src ? (src.content || src).textContent : '')).toLowerCase();
        }
        return b.kHay;
      }
      function filter(reset) {
        var any = false;
        qs.forEach(function (b) {
          b.hidden = b.dataset.used === '1' || (words.length
            ? !words.every(function (w) { return hay(b).indexOf(w) > -1; })
            : (tab && b.dataset.t !== tab));
          if (!b.hidden) any = true;
        });
        sec.classList.toggle('is-finding', words.length > 0);
        /* each tab shows how many of its questions are still unasked */
        tabs.forEach(function (t) {
          var n = t.querySelector('.k-th-tn');
          if (!n) return;
          var left = qs.filter(function (b) { return b.dataset.t === t.dataset.t && b.dataset.used !== '1'; }).length;
          n.textContent = left || '';
        });
        /* a new topic or search starts its chip row from the left; asking a chip keeps the place */
        if (reset && sec.querySelector('.k-th-qrow')) sec.querySelector('.k-th-qs').scrollLeft = 0;
        if (edges) edges();
        if (done) done.hidden = any || words.length > 0;
        if (none) none.hidden = any || !words.length;
      }
      function add(cls, html) {
        var m = document.createElement('div');
        m.className = cls;
        m.innerHTML = html;
        log.appendChild(m);
        return m;
      }
      function show(el) { log.scrollTo({ top: Math.max(0, el.offsetTop - 16), behavior: reduce ? 'auto' : 'smooth' }); }
      function ask(b) {
        var tpl = document.getElementById(b.dataset.a);
        if (busy || !tpl) return;
        var kb = b.matches(':focus-visible');
        b.dataset.used = '1';
        var q = add('k-th-msg k-th-q is-new', esc(b.textContent.trim()));
        track('sunburn_faq_open', { question: b.textContent.trim().slice(0, 100) });
        filter();
        var next = qs.filter(function (x) { return !x.hidden; })[0];
        /* the asked chip disappears: keep keyboard focus in the chip row */
        if (next && kb) next.focus({ preventScroll: true });
        show(q);
        function reply() { add('k-th-msg k-th-a is-new', tpl.innerHTML); show(q); }
        if (reduce) return reply();
        busy = true;
        var dots = add('k-th-dots', '<i></i><i></i><i></i>');
        dots.setAttribute('aria-hidden', 'true');
        show(q);
        setTimeout(function () { dots.remove(); reply(); busy = false; }, 650 + Math.min(tpl.innerHTML.replace(/<[^>]+>/g, '').length, 260) * 2);
      }
      qs.forEach(function (b) { b.addEventListener('click', function () { ask(b); }); });
      if (find) {
        find.addEventListener('input', function () {
          words = find.value.toLowerCase().split(/\s+/).filter(Boolean);
          filter(true);
        });
        find.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          var first = qs.filter(function (x) { return !x.hidden; })[0];
          if (!first || busy) return;
          find.value = '';
          words = [];
          ask(first);
        });
      }
      /* FAQ page: chips stay on one row; arrows and edge fades show when there is more to either side */
      var row = sec.querySelector('.k-th-qrow'), rail = sec.querySelector('.k-th-qs');
      var prev = sec.querySelector('.k-th-prev'), next = sec.querySelector('.k-th-next');
      if (row) {
        edges = function () {
          var max = rail.scrollWidth - rail.clientWidth;
          var l = rail.scrollLeft > 2, r = rail.scrollLeft < max - 2;
          row.classList.toggle('can-l', l);
          row.classList.toggle('can-r', r);
          prev.hidden = !l;
          next.hidden = !r;
        };
        function step(dir) { rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); }
        prev.addEventListener('click', function () { step(-1); });
        next.addEventListener('click', function () { step(1); });
        rail.addEventListener('scroll', edges, { passive: true });
        window.addEventListener('resize', edges);
        edges();
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tab = t.dataset.t;
          if (find && words.length) { find.value = ''; words = []; }
          tabs.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
          filter(true);
        });
      });
      filter();
    });
  }

  /* home page only: section content eases in as it reaches the viewport (moment surface, A-14).
     Never on task pages, never with reduced motion; without JS nothing is hidden. */
  var revealIO = null;
  function initReveal(root) {
    if (reduce || !document.body.classList.contains('k-tpl-index') || !('IntersectionObserver' in window)) return;
    if (!revealIO) {
      document.documentElement.classList.add('k-rv-on');
      revealIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.classList.add('is-in');
          revealIO.unobserve(el);
          /* hand transform back to the hover lifts once the entrance is done */
          setTimeout(function () { el.classList.remove('k-reveal', 'is-in'); el.style.removeProperty('--k-d'); }, 1200);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    var LISTS = '.k-grid, .k-sm-steps, .k-notes, .k-reels, .k-rail';
    function watch(el, k) {
      if (el.classList.contains('k-reveal')) return;
      el.classList.add('k-reveal');
      if (k) el.style.setProperty('--k-d', Math.min(k, 6) * 0.07 + 's');
      revealIO.observe(el);
    }
    root.querySelectorAll('.k-sec .k-wrap > *').forEach(function (el) {
      var list = el.matches(LISTS) ? el : el.querySelector(LISTS);
      /* lists reveal item by item (common fate, I-14); everything else as one piece */
      if (list) Array.prototype.forEach.call(list.children, watch);
      else watch(el, 0);
    });
  }

  /* step cards: actives on one line when they fit at 10px or more, otherwise let them wrap */
  function initChips(root) {
    var rows = root.querySelectorAll('.k-sm-chips');
    if (!rows.length) return;
    /* scrollWidth leaves out the row's right padding, so measure the last chip against it */
    function over(row) {
      var edge = row.getBoundingClientRect().right - parseFloat(getComputedStyle(row).paddingRight);
      return row.lastElementChild.getBoundingClientRect().right > edge + 0.5;
    }
    /* every card that fits gets the same size: the largest one that fits them all */
    function fit() {
      var min = Infinity;
      rows.forEach(function (row) {
        if (!row.children.length) return;
        row.style.removeProperty('--chip-fs');
        row.classList.add('is-line');
        var fs = parseFloat(getComputedStyle(row.firstElementChild).fontSize);
        while (over(row) && fs > 10) {
          fs = Math.max(10, fs - 0.5);
          row.style.setProperty('--chip-fs', fs + 'px');
        }
        if (over(row)) {
          row.classList.remove('is-line');
          row.style.removeProperty('--chip-fs');
        } else {
          min = Math.min(min, fs);
        }
      });
      if (min === Infinity) return;
      rows.forEach(function (row) {
        if (row.classList.contains('is-line')) row.style.setProperty('--chip-fs', min + 'px');
      });
    }
    fit();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  /* philosophy: fan of pledge cards that always rotates (a click moves it on); photos drift on scroll.
     Only keyboard focus holds it, so a tabbing reader can read the front card. */
  function initPhilo(root) {
    root.querySelectorAll('[data-k-phm]').forEach(function (sec) {
      if (sec.dataset.kInit) return;
      sec.dataset.kInit = '1';
      var cards = sec.querySelectorAll('.k-phm-card');
      var n = cards.length, front = 0, timer = null, held = false;
      if (!n) return;
      function show(i) {
        front = (i + n) % n;
        cards.forEach(function (c, k) {
          var on = k === front;
          c.dataset.pos = (k - front + n) % n;
          c.setAttribute('aria-hidden', on ? 'false' : 'true');
          c.tabIndex = on ? 0 : -1;
        });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function play() { stop(); if (!held && !document.hidden && n > 1) timer = setInterval(function () { show(front + 1); }, 4200); }
      cards.forEach(function (c) { c.addEventListener('click', function () { show(front + 1); play(); }); });
      sec.addEventListener('focusin', function (e) { if (e.target.matches(':focus-visible')) { held = true; stop(); } });
      sec.addEventListener('focusout', function () { held = false; play(); });
      document.addEventListener('visibilitychange', play);
      show(0); play();
      if (reduce) return;
      var imgs = sec.querySelectorAll('.k-phm-card img'), raf = 0;
      function drift() {
        raf = 0;
        var r = sec.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        var y = ((r.top + r.height / 2 - innerHeight / 2) / innerHeight * -50).toFixed(1) + 'px';
        imgs.forEach(function (im) { im.style.setProperty('--py', y); });
      }
      window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(drift); }, { passive: true });
      drift();
    });
  }

  /* animated logo (snippets/sunburn-logo.liquid). The head script plays data-trigger="load" logos on
     every page load; here the header logo replays each time the page comes back to the top, and
     data-trigger="view" logos (footer) hold their first frame and draw in every time they scroll into view. */
  var logoIO, logoTopBound = false;
  function restart(el, cls) {
    el.classList.remove('is-playing', 'is-armed', 'is-inview');
    void el.getBoundingClientRect(); /* reflow so the same animation starts again from 0 */
    el.classList.add(cls);
  }
  function initLogo(root) {
    if (reduce) return;
    if (!logoTopBound) {
      logoTopBound = true;
      var away = false;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (y > 200) away = true;
        else if (away && y < 8) {
          away = false;
          /* the intro class would keep the first run applied; hand replays over to .is-playing */
          document.documentElement.classList.remove('ss-logo-intro');
          document.querySelectorAll('.ss-logo[data-trigger="load"]').forEach(function (el) { restart(el, 'is-playing'); });
        }
      }, { passive: true });
    }
    if (!('IntersectionObserver' in window)) return;
    if (!logoIO) {
      logoIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.6) e.target.classList.add('is-inview');
          else if (!e.isIntersecting && e.target.classList.contains('is-inview')) restart(e.target, 'is-armed');
        });
      }, { threshold: [0, 0.6] });
    }
    root.querySelectorAll('.ss-logo[data-trigger="view"]:not(.is-armed)').forEach(function (el) {
      el.classList.add('is-armed');
      logoIO.observe(el);
    });
  }

  /* Wet glass footer (sections/sunburn-footer.liquid): the photo behind the glass cards ripples like
     liquid. A small height-map water simulation runs on a canvas drawn over the photo, only while the
     footer is on screen; the pointer and an occasional random drop disturb it. With reduced motion, or if
     the photo can't be read back (cross-origin), the plain photo stays. */
  function initWetGlass(root) {
    if (reduce) return;
    root.querySelectorAll('[data-k-wg]:not(.is-wg)').forEach(function (box) {
      var img = box.querySelector('.k-wg-ph'), cv = box.querySelector('.k-wg-cv');
      if (!img || !cv || !cv.getContext) return;
      box.classList.add('is-wg');
      var ctx = cv.getContext('2d', { willReadFrequently: true });
      var W, H, a = null, b, src, out, run = false, vis = false, lx = -1, ly = -1, dead = false;
      function setup() {
        a = null;
        var bw = box.clientWidth, bh = box.clientHeight;
        if (dead || !img.naturalWidth || !bw || !bh) return;
        /* simulate at reduced resolution: at most 820px wide and about 320k cells */
        var s = Math.min(1, 820 / bw, Math.sqrt(320000 / (bw * bh)));
        W = Math.max(3, Math.round(bw * s)); H = Math.max(3, Math.round(bh * s));
        cv.width = W; cv.height = H;
        var sc = Math.max(W / img.naturalWidth, H / img.naturalHeight), dw = img.naturalWidth * sc, dh = img.naturalHeight * sc;
        var pos = (getComputedStyle(img).objectPosition || '50% 50%').split(' ');
        var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || pos[0]) / 100;
        if (isNaN(px)) px = 0.5;
        if (isNaN(py)) py = 0.5;
        ctx.drawImage(img, (W - dw) * px, (H - dh) * py, dw, dh);
        try { src = ctx.getImageData(0, 0, W, H); } catch (err) { dead = true; cv.remove(); box.classList.remove('is-live'); return; }
        out = ctx.createImageData(W, H);
        a = new Float32Array(W * H); b = new Float32Array(W * H);
        box.classList.add('is-live');
      }
      function poke(x, y, r, f) {
        x |= 0; y |= 0;
        for (var j = -r; j <= r; j++) for (var i = -r; i <= r; i++) {
          var X = x + i, Y = y + j;
          if (X > 0 && X < W - 1 && Y > 0 && Y < H - 1 && i * i + j * j <= r * r) a[Y * W + X] += f;
        }
      }
      function step() {
        var x, y, k;
        for (y = 1; y < H - 1; y++) for (x = 1; x < W - 1; x++) {
          k = y * W + x;
          b[k] = ((a[k - 1] + a[k + 1] + a[k - W] + a[k + W]) / 2 - b[k]) * 0.968;
        }
        var t = a; a = b; b = t;
        var sd = src.data, od = out.data;
        for (y = 1; y < H - 1; y++) for (x = 1; x < W - 1; x++) {
          k = y * W + x;
          var dx = a[k - 1] - a[k + 1], dy = a[k - W] - a[k + W];
          var sx = Math.min(W - 1, Math.max(0, x + dx * 0.1 | 0)), sy = Math.min(H - 1, Math.max(0, y + dy * 0.1 | 0));
          var si = (sy * W + sx) * 4, oi = k * 4, l = (dx - dy) * 0.2;
          od[oi] = sd[si] + l; od[oi + 1] = sd[si + 1] + l; od[oi + 2] = sd[si + 2] + l; od[oi + 3] = 255;
        }
        ctx.putImageData(out, 0, 0);
      }
      function loop() { if (!run) return; if (a) step(); requestAnimationFrame(loop); }
      function go() { if (!run && vis && !document.hidden && !dead) { run = true; requestAnimationFrame(loop); } }
      function at(e) { var r = box.getBoundingClientRect(); return [(e.clientX - r.left) * W / r.width, (e.clientY - r.top) * H / r.height]; }
      box.addEventListener('pointermove', function (e) {
        if (!a) return;
        var p = at(e);
        if (Math.abs(p[0] - lx) + Math.abs(p[1] - ly) > 2) { poke(p[0], p[1], 3, 140); lx = p[0]; ly = p[1]; }
      });
      box.addEventListener('pointerdown', function (e) { if (a) { var p = at(e); poke(p[0], p[1], 5, 320); } });
      setInterval(function () { if (run && a) poke(Math.random() * W, Math.random() * H * 0.6, 3, 260); }, 1300);
      new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis) go(); else run = false; }).observe(box);
      document.addEventListener('visibilitychange', function () { if (document.hidden) run = false; else go(); });
      var rt;
      if ('ResizeObserver' in window) new ResizeObserver(function () { clearTimeout(rt); rt = setTimeout(setup, 200); }).observe(box);
      if (img.complete && img.naturalWidth) setup(); else img.addEventListener('load', setup);
    });
  }

  /* app motion on phones (sunburn.css "App motion"): drag the cart / Saved sheets down or the menu left
     to close them, and dim the page with a loading line while the next screen loads */
  function dragToClose(panel, handleSel, axis, close) {
    var x0, y0, d = 0, t0, on = false, locked = false;
    panel.addEventListener('touchstart', function (e) {
      if (!phone.matches || e.touches.length !== 1) return;
      var h = handleSel ? e.target.closest(handleSel) : panel;
      if (!h || e.target.closest('input, select, textarea')) return;
      /* inside a scrolled list, only a pull from the very top drags the sheet */
      var sc = e.target.closest('.k-cd-scroll, .k-wd-scroll, .drawer__inner-empty, .menu-drawer__navigation-container');
      if (axis === 'y' && sc && sc.scrollTop > 0) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; d = 0; t0 = Date.now(); on = true; locked = false;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (!on) return;
      var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
      if (!locked) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        /* the gesture has to go the closing way first, or it stays a normal scroll */
        if (axis === 'y' ? (dy <= 0 || Math.abs(dx) > dy) : (dx >= 0 || Math.abs(dy) > -dx)) { on = false; return; }
        locked = true;
        panel.classList.add('is-drag');
      }
      d = axis === 'y' ? Math.max(0, dy) : Math.min(0, dx);
      panel.style.transform = axis === 'y' ? 'translateY(' + d + 'px)' : 'translateX(' + d + 'px)';
      if (e.cancelable) e.preventDefault();
    }, { passive: false });
    function end() {
      if (!on) return;
      on = false;
      if (!locked) return;
      var size = axis === 'y' ? panel.offsetHeight : panel.offsetWidth;
      var fast = Math.abs(d) / Math.max(1, Date.now() - t0) > 0.6;
      panel.classList.remove('is-drag');
      panel.style.transform = '';
      if (Math.abs(d) > size * 0.25 || (fast && Math.abs(d) > 30)) close();
    }
    panel.addEventListener('touchend', end);
    panel.addEventListener('touchcancel', end);
  }
  var phone = window.matchMedia('(max-width: 749px)');
  function initAppMotion() {
    if (document.documentElement.dataset.kApp) return;
    document.documentElement.dataset.kApp = '1';

    var cd = document.querySelector('cart-drawer');
    var cdPanel = cd && cd.querySelector('.drawer__inner');
    /* Dawn re-renders the cart's inner markup but keeps .drawer__inner, so one binding lasts */
    if (cdPanel) dragToClose(cdPanel, '.k-cd-head, .k-cd-scroll, .drawer__inner-empty', 'y', function () { cd.close(); });
    var wdPanel = document.querySelector('#k-wd .k-wd-panel');
    if (wdPanel) dragToClose(wdPanel, '.k-wd-head, .k-wd-scroll', 'y', function () {
      var x = document.querySelector('#k-wd [data-k-wd-close]');
      if (x) x.click();
    });
    var menu = document.getElementById('menu-drawer');
    var menuBtn = document.querySelector('header-drawer summary.header__icon--menu');
    if (menu && menuBtn) {
      /* phones: the menu is a bottom sheet, so it drags down to close like the bag and Saved sheets */
      dragToClose(menu, '.k-mn-head, .menu-drawer__navigation-container', 'y', function () { menuBtn.click(); });
      menu.addEventListener('click', function (e) {
        if (!e.target.closest('[data-k-menu-close]')) return;
        e.preventDefault();
        menuBtn.click();
      });
    }

    /* leaving for another page: dim the screen and run the loading line (CSS); undone if the page comes back from cache */
    document.addEventListener('click', function (e) {
      if (!phone.matches || reduce || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]');
      if (!a || a.target && a.target !== '_self' || a.hasAttribute('download') || a.origin !== location.origin) return;
      if (a.pathname === location.pathname && a.search === location.search) return;
      if (/^\/(cart|checkout|account)/.test(a.pathname) && a.closest('form')) return;
      document.body.classList.add('k-leave');
      clearTimeout(leaveTimer);
      leaveTimer = setTimeout(function () { document.body.classList.remove('k-leave'); }, 6000);
    });
    window.addEventListener('pageshow', function () { document.body.classList.remove('k-leave'); });
  }
  var leaveTimer;

  /* phone app tab bar (snippets/sunburn-tabbar). Bag opens the cart drawer and mirrors the header bag's
     count (Dawn re-renders #cart-icon-bubble after every add); tapping the tab you are already on scrolls
     back to the top, and Search focuses the field, as an app would. Saved is wired by initWish. */
  function initTabs() {
    var bar = document.querySelector('[data-k-tabbar]');
    if (!bar || bar.dataset.kInit) return;
    bar.dataset.kInit = '1';
    var bag = bar.querySelector('[data-k-tab="bag"]');
    var n = bar.querySelector('[data-k-tab-bag]');
    var src = document.getElementById('cart-icon-bubble');
    function sync() {
      if (!n || !src) return;
      var bub = src.querySelector('.cart-count-bubble');
      var c = bub ? (bub.querySelector('[aria-hidden]') ? bub.querySelector('[aria-hidden]').textContent.trim() : '99+') : '';
      if (c === '0') c = '';
      if (c === n.textContent && !n.hidden === !!c) return;
      var up = c && (parseInt(c, 10) || 100) > (parseInt(n.textContent, 10) || 0);
      n.textContent = c;
      n.hidden = !c;
      if (up && !reduce) { bag.classList.remove('is-bump'); void bag.offsetWidth; bag.classList.add('is-bump'); }
    }
    if (src && 'MutationObserver' in window) new MutationObserver(sync).observe(src, { childList: true, subtree: true, characterData: true });
    sync();

    /* one pill that glides to the tapped tab before the next screen loads */
    var ind = document.createElement('span');
    ind.className = 'k-tab-ind';
    ind.setAttribute('aria-hidden', 'true');
    bar.insertBefore(ind, bar.firstChild);
    function place(t, still) {
      if (!t) { ind.hidden = true; bar.classList.remove('has-ind'); return; }
      var i = t.querySelector('.k-tab-i');
      if (still) ind.style.transition = 'none';
      ind.hidden = false;
      ind.style.top = (t.offsetTop + i.offsetTop) + 'px';
      ind.style.transform = 'translateX(' + (t.offsetLeft + i.offsetLeft) + 'px)';
      bar.classList.add('has-ind');
      if (still) { void ind.offsetWidth; ind.style.transition = ''; }
    }
    function current() { return bar.querySelector('.k-tab--menu.is-open') || bar.querySelector('.k-tab[aria-current="page"]'); }
    place(current(), true);
    window.addEventListener('resize', function () { place(current(), true); });

    /* Menu tab drives the header's own drawer (Dawn's header-drawer), so both buttons share one menu */
    var menuTab = bar.querySelector('[data-k-tab="menu"]');
    var menuBox = document.getElementById('Details-menu-drawer-container');
    var menuBtn = menuBox && menuBox.querySelector('summary');
    if (menuTab && !menuBtn) menuTab.hidden = true;
    if (menuTab && menuBtn) {
      var menuOpen = function () { return menuBox.hasAttribute('open') && menuBox.classList.contains('menu-opening'); };
      new MutationObserver(function () {
        var on = menuOpen();
        if (on === menuTab.classList.contains('is-open')) return;
        menuTab.classList.toggle('is-open', on);
        menuTab.setAttribute('aria-expanded', on ? 'true' : 'false');
        bar.classList.toggle('is-menu', on);
        place(current());
      }).observe(menuBox, { attributes: true, attributeFilter: ['class', 'open'] });
      menuTab.addEventListener('click', function () { menuBtn.click(); });
      /* any other tab closes the menu first */
      bar.addEventListener('click', function (e) {
        var t = e.target.closest('.k-tab');
        if (t && t !== menuTab && menuOpen()) menuBtn.click();
      }, true);
    }
    bar.addEventListener('click', function (e) {
      var t = e.target.closest('.k-tab');
      if (!t || reduce) return;
      t.classList.remove('is-tap'); void t.offsetWidth; t.classList.add('is-tap');
      if (t.tagName === 'A' && t !== bag && !e.defaultPrevented && t.pathname !== location.pathname) {
        bar.querySelectorAll('.k-tab[aria-current]').forEach(function (c) { c.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'page');
        place(t);
      }
    }, true);

    function focusSearch() {
      var f = document.getElementById('Search-In-Template');
      if (!f) return false;
      f.focus({ preventScroll: true });
      return true;
    }
    bar.addEventListener('click', function (e) {
      var t = e.target.closest('a.k-tab');
      if (!t) return;
      if (t === bag) {
        var drawer = document.querySelector('cart-drawer');
        if (t.getAttribute('aria-current') || !drawer || typeof drawer.open !== 'function') return;
        e.preventDefault();
        drawer.open(bag);
        return;
      }
      try { sessionStorage.setItem('k_tab', t.dataset.kTab); } catch (err) {}
      if (t.pathname !== location.pathname) return;
      e.preventDefault();
      if (t.dataset.kTab === 'search') focusSearch();
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    /* arrived on the search screen from the tab with nothing typed yet: put the cursor in the field */
    var from = '';
    try { from = sessionStorage.getItem('k_tab'); sessionStorage.removeItem('k_tab'); } catch (err) {}
    var f = document.getElementById('Search-In-Template');
    if (from === 'search' && f && !f.value && window.matchMedia('(max-width: 749px)').matches) focusSearch();
  }

  /* Policy pages: the contents list follows the section being read, the bar fills with reading progress,
     and on phones the list is a closed bar that shows the current section and shuts after a jump. */
  function initPolicy(root) {
    root.querySelectorAll('[data-k-pol]').forEach(function (pol) {
      if (pol.dataset.kInit) return;
      pol.dataset.kInit = '1';
      var toc = pol.querySelector('[data-k-pol-toc]');
      if (!toc) return;
      var links = Array.prototype.slice.call(toc.querySelectorAll('[data-k-pol-link]'));
      var secs = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
      var doc = pol.querySelector('.k-pol-doc');
      var cur = toc.querySelector('[data-k-pol-cur]');
      var bar = toc.querySelector('[data-k-pol-bar]');
      var list = toc.querySelector('.k-pol-list');
      var mq = window.matchMedia('(max-width: 900px)');
      var on = -1;
      function fit() { if (mq.matches) toc.removeAttribute('open'); else toc.setAttribute('open', ''); }
      fit();
      if (mq.addEventListener) mq.addEventListener('change', fit);
      var bars = document.querySelectorAll('.shopify-section-group-header-group');
      var lastTop = -1;
      function update() {
        /* the announcement and the header both stick; sit the contents under whatever of them is showing */
        var top = 0;
        bars.forEach(function (b) {
          if (getComputedStyle(b).position !== 'sticky') return;
          var r = b.getBoundingClientRect();
          if (r.bottom > top && r.top <= top + 2) top = r.bottom; /* stacked: each bar starts where the last ends */
        });
        top = Math.round(Math.max(0, top));
        if (top !== lastTop) { pol.style.setProperty('--k-pol-top', top + 'px'); lastTop = top; }
        var line = top + 90;
        var i = -1;
        secs.forEach(function (sec, k) { if (sec && sec.getBoundingClientRect().top <= line) i = k; });
        if (i !== on) {
          if (on > -1) links[on].classList.remove('is-on');
          if (i > -1) {
            links[i].classList.add('is-on');
            if (!mq.matches && list) {
              var a = links[i];
              if (a.offsetTop < list.scrollTop || a.offsetTop + a.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = a.offsetTop - list.clientHeight / 2;
            }
          }
          if (cur) cur.textContent = i > -1 ? links[i].lastElementChild.textContent.trim() : '';
          toc.classList.toggle('has-cur', i > -1);
          on = i;
        }
        if (bar && doc) {
          var r = doc.getBoundingClientRect();
          var p = Math.min(1, Math.max(0, (window.innerHeight * 0.4 - r.top) / Math.max(1, r.height - window.innerHeight * 0.4)));
          bar.style.setProperty('--p', p.toFixed(3));
        }
      }
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
      update();
      /* the header slides back in without a scroll event; re-measure when it lands */
      bars.forEach(function (b) { b.addEventListener('transitionend', update); });
      /* the header also tightens once scrolled (height change, no scroll event) */
      if (window.ResizeObserver) { var ro = new ResizeObserver(function () { update(); }); bars.forEach(function (b) { ro.observe(b); }); }
      setTimeout(update, 500);
      pol.addEventListener('click', function (e) {
        var a = e.target.closest('a[href^="#"]');
        if (!a) return;
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        e.preventDefault();
        if (mq.matches) toc.removeAttribute('open');
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
      });
      document.addEventListener('click', function (e) {
        if (mq.matches && toc.hasAttribute('open') && !toc.contains(e.target)) toc.removeAttribute('open');
      });
    });
  }

  /* Ingredients page (sections/sunburn-ingredients.liquid). Product chips filter the cards and show each
     card's strength in that formula; "Found in" chips and the corner arrow open that formula's label below;
     a label line jumps back to its card. Tabs follow the ARIA tabs pattern (arrows, Home, End). */
  function initIng(root) {
    root.querySelectorAll('[data-k-ing]').forEach(function (pg) {
      if (pg.dataset.kInit) return;
      pg.dataset.kInit = '1';
      var sec = pg.parentElement;
      var lab = sec.querySelector('[data-k-igl]');
      var cards = Array.prototype.slice.call(pg.querySelectorAll('[data-k-ig]'));
      var chips = Array.prototype.slice.call(pg.querySelectorAll('[data-k-ig-f]'));
      var count = pg.querySelector('[data-k-ig-count]');
      var empty = pg.querySelector('[data-k-ig-empty]');
      var tabs = lab ? Array.prototype.slice.call(lab.querySelectorAll('[data-k-igl-t]')) : [];
      var smooth = reduce ? 'auto' : 'smooth';

      function filter(f) {
        var name = '';
        chips.forEach(function (c) {
          var on = c.dataset.kIgF === f;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on && f) name = c.firstChild.textContent.trim();
        });
        var n = 0;
        cards.forEach(function (c) {
          var on = !f || c.dataset.in.indexOf(' ' + f + ' ') > -1;
          c.hidden = !on;
          if (!on) return;
          var pct = c.querySelector('[data-k-ig-pct]');
          var t = f ? c.getAttribute('data-' + f) : c.dataset.all;
          pct.textContent = t || 'In the blend';
          pct.classList.toggle('is-none', !t);
          c.querySelectorAll('.k-ig-f').forEach(function (b) { b.classList.toggle('is-on', !!f && b.dataset.kIgGo === f); });
          if (!reduce) {
            c.style.setProperty('--i', Math.min(n, 8));
            c.classList.remove('is-shown');
            void c.offsetWidth;
            c.classList.add('is-shown');
          }
          n++;
        });
        if (count) count.textContent = n + (n === 1 ? ' active' : ' actives') + (name ? ' in the ' + name : '');
        if (empty) empty.hidden = n > 0;
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () { filter(c.classList.contains('is-on') ? '' : c.dataset.kIgF); });
      });

      function show(f, focus) {
        var tab = null;
        tabs.forEach(function (t) {
          var on = t.dataset.kIglT === f;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on) tab = t;
        });
        if (!tab) return;
        lab.querySelectorAll('[data-k-igl-p]').forEach(function (p) {
          var on = p.dataset.kIglP === f;
          p.hidden = !on;
          p.classList.toggle('is-on', on);
        });
        var row = tab.parentElement;
        var x = tab.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2;
        row.scrollTo({ left: Math.max(0, x), behavior: smooth });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(t.dataset.kIglT); });
        t.addEventListener('keydown', function (e) {
          var j = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
          if (j == null) return;
          e.preventDefault();
          show(tabs[(j + tabs.length) % tabs.length].dataset.kIglT, true);
        });
      });
      /* the first label's bars grow when it comes into view; later ones grow as their tab opens */
      if (lab && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return;
          lab.classList.add('is-seen');
          io.disconnect();
        }, { threshold: 0.25 });
        io.observe(lab);
      } else if (lab) lab.classList.add('is-seen');

      sec.addEventListener('click', function (e) {
        var go = e.target.closest('[data-k-ig-go]');
        if (go && lab) {
          e.preventDefault();
          show(go.dataset.kIgGo);
          lab.scrollIntoView({ behavior: smooth, block: 'start' });
          return;
        }
        var to = e.target.closest('[data-k-ig-to]');
        if (!to) return;
        var card = document.getElementById(to.dataset.kIgTo);
        if (!card) return;
        e.preventDefault();
        if (card.hidden) filter('');
        card.scrollIntoView({ behavior: smooth, block: 'center' });
        card.classList.remove('is-flash');
        void card.offsetWidth;
        card.classList.add('is-flash');
      });
    });
  }

  /* About page Card Stack (sections/sunburn-about.liquid): the deck's stage pins under the sticky bars;
     scroll progress deals the cards. Card i flies up (tilted) as progress passes i-1; every card under the
     top one scales back 4.5%, shifts up a peek and dims, up to three deep. Short screens / reduced motion
     get .is-flat, a plain list. */
  function initAbout(root) {
    root.querySelectorAll('[data-k-ab-deck]').forEach(function (deck) {
      if (deck.dataset.kInit) return;
      deck.dataset.kInit = '1';
      var stage = deck.firstElementChild;
      var items = Array.prototype.slice.call(deck.querySelectorAll('.k-ab-item'));
      var n = items.length;
      if (!n) return;
      var dots = Array.prototype.slice.call(deck.querySelectorAll('.k-ab-rail i'));
      var count = deck.querySelector('[data-k-ab-count]');
      var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
      var bars = document.querySelectorAll('.shopify-section-group-header-group, .shopify-section:has(> [data-k-stick])');
      var tabbar = document.querySelector('[data-k-tabbar]');
      var flat = false, lastTop = -1, lastH = -1, top = 0;
      function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
      function ease(t) { return 1 - Math.pow(1 - t, 3); }
      function measure() {
        var t = 0;
        bars.forEach(function (b) {
          if (getComputedStyle(b).position !== 'sticky') return;
          var r = (b.querySelector(':scope > .header-wrapper') || b).getBoundingClientRect();
          if (r.bottom > t && r.top <= t + 2) t = r.bottom;
        });
        t = Math.round(Math.max(0, t));
        var tb = 0;
        if (tabbar) { var tr = tabbar.getBoundingClientRect(); if (tr.height && getComputedStyle(tabbar).display !== 'none') tb = Math.max(0, window.innerHeight - tr.top); }
        var h = Math.round(window.innerHeight - t - tb);
        if (t !== lastTop) { deck.style.setProperty('--k-ab-top', t + 'px'); lastTop = t; }
        if (h !== lastH) { deck.style.setProperty('--k-ab-h', h + 'px'); lastH = h; }
        top = t;
        return h;
      }
      function fit() {
        var h = measure();
        flat = rm.matches || h < 500;
        deck.classList.toggle('is-flat', flat);
        /* a card whose words outgrow it: smaller type first, then drop its photo */
        items.forEach(function (it) {
          it.classList.remove('is-tight', 'is-tighter');
          if (flat) return;
          var card = it.querySelector('.k-ab-nc'), inn = it.querySelector('.k-ab-in');
          if (!card || !inn) return;
          var over = function () { return inn.scrollHeight > card.clientHeight + 1; };
          if (over()) it.classList.add('is-tight');
          if (over()) it.classList.add('is-tighter');
        });
        tick();
      }
      function tick() {
        if (flat) {
          items.forEach(function (it) { it.style.transform = ''; it.style.opacity = ''; it.classList.add('is-landed'); });
          return;
        }
        var H = measure();
        var r = deck.getBoundingClientRect();
        var span = Math.max(1, r.height - H);
        var f = clamp((top - r.top) / span, 0, 1) * (n - 1);
        var e = items.map(function (_, i) { return i === 0 ? 1 : ease(clamp(f - (i - 1), 0, 1)); });
        var peek = parseFloat(getComputedStyle(deck).getPropertyValue('--peek')) || 20;
        var on = 0;
        items.forEach(function (it, i) {
          var d = 0;
          for (var j = i + 1; j < n; j++) d += e[j];
          var dd = Math.min(d, 3);
          var enter = (1 - e[i]) * (H + 60);
          var rot = (1 - e[i]) * (i % 2 ? 3 : -3);
          it.style.transform = 'translateY(' + (enter - dd * peek).toFixed(1) + 'px) scale(' + (1 - dd * 0.045).toFixed(4) + ') rotate(' + rot.toFixed(2) + 'deg)';
          it.style.opacity = d > 3 ? Math.max(0, 1 - (d - 3) * 2) : '';
          it.style.zIndex = i;
          it.style.pointerEvents = d > 0.5 ? 'none' : '';
          var nc = it.querySelector('.k-ab-nc'), dot = it.querySelector('.k-ab-dot');
          if (nc) nc.style.setProperty('--dim', (dd * 0.07).toFixed(3));
          if (dot) dot.style.opacity = d > 0.15 ? 0 : '';
          if (e[i] > 0.5) on = i;
          it.classList.toggle('is-landed', e[i] > 0.97);
        });
        dots.forEach(function (dt, i) { dt.classList.toggle('is-on', i <= on); dt.classList.toggle('is-now', i === on); });
        if (count) count.textContent = (on + 1) + ' / ' + n;
      }
      var ticking = false;
      function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; tick(); }); }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', fit);
      if (rm.addEventListener) rm.addEventListener('change', fit);
      if (window.ResizeObserver) { var ro = new ResizeObserver(onScroll); bars.forEach(function (b) { ro.observe(b); }); }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
      window.addEventListener('load', fit);
      fit();
    });
  }

  function init(root) {
    root = root || document;
    initLogo(root);
    initWetGlass(root);
    initReveal(root);
    initAnnouncements(root);
    initHero(root);
    initRails(root);
    initRvPhotos(root);
    initChips(root);
    initTrust(root);
    initPhilo(root);
    initThread(root);
    initPolicy(root);
    initAbout(root);
    initIng(root);
    initBars(root);
    initReels(root);
    initPin(root);
    initDeals(root);
    initUrg();
    initFbt(root);
    initGalNav(root);
    initPackPick(root);
    initOffers(root);
    initSticky(root);
    initRecent(root);
    initSaved(root);
    initGenie(root);
    wishCount();
    initWish();
    initTop();
    initTabs();
    initAppMotion();
  }
  /* Collection sort dropdown (k-sort): sets the hidden #SortBy select and lets facets.js re-render.
     Delegated because facets.js swaps the .sorting markup after every filter change.
     Also closes open filter/sort popovers on an outside click or Escape. */
  /* Budget chips: filter in place through facets.js like every other filter (a plain link reloads
     the page and drops availability + sort). Chip state follows the URL after any filter change. */
  function bandsSync() {
    var p = new URLSearchParams(location.search);
    document.querySelectorAll('.k-bands').forEach(function (nav) {
      var lo = +(p.get(nav.dataset.min) || 0), hi = +(p.get(nav.dataset.max) || 0);
      nav.querySelectorAll('[data-k-band]').forEach(function (c) {
        var on = (lo || hi) && lo === +c.dataset.lo && hi === +(c.dataset.hi || 0);
        c.classList.toggle('is-on', !!on);
        if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      });
    });
  }
  document.addEventListener('click', function (e) {
    var band = e.target.closest('[data-k-band]');
    if (band && window.FacetFiltersForm && document.getElementById('ProductGridContainer') && !(e.metaKey || e.ctrlKey || e.shiftKey || e.button)) {
      e.preventDefault();
      var nav = band.closest('.k-bands'), p = new URLSearchParams(location.search);
      p.delete(nav.dataset.min); p.delete(nav.dataset.max); p.delete('page');
      if (!band.classList.contains('is-on')) {
        if (+band.dataset.lo > 0) p.set(nav.dataset.min, band.dataset.lo);
        if (band.dataset.hi) p.set(nav.dataset.max, band.dataset.hi);
      }
      FacetFiltersForm.renderPage(p.toString());
      bandsSync();
      return;
    }
    var opt = e.target.closest('[data-k-sort]');
    if (opt) {
      var box = opt.closest('.sorting');
      var sel = box && box.querySelector('select[name="sort_by"]');
      if (!sel) return;
      box.querySelectorAll('[data-k-sort]').forEach(function (b) { b.setAttribute('aria-selected', b === opt ? 'true' : 'false'); });
      var cur = box.querySelector('.k-sort__cur');
      if (cur) cur.textContent = opt.textContent.trim();
      opt.closest('details').removeAttribute('open');
      if (sel.value !== opt.dataset.kSort) {
        sel.value = opt.dataset.kSort;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
      }
      return;
    }
    document.querySelectorAll('.k-sort[open], .facets__disclosure[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('.k-sort[open]');
    if (d) { d.removeAttribute('open'); d.querySelector('summary').focus(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
